
window.slate = window.slate || {};
window.theme = window.theme || {};

String.prototype.capitalize = function()
{
    return this.replace(/-/g, ' ').replace(/(^|\s)([a-z])/g, function(m, p1, p2) { return p1 + p2.toUpperCase(); });
};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element)
    {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback()
        {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function()
    {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1)))
        {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function()
    {
        $('a[href*=#]').on('click', function(evt)
        {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options)
    {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (!options.$elementToFocus)
        {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function(evt)
        {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length)
            {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options)
    {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length)
        {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function()
    {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled)
        {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value)
    {
        for (var i = 0; i < array.length; i++)
        {
            if (array[i][key] === value)
            {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value)
    {
        var i = array.length;
        while (i--)
        {
            if (array[i][key] === value)
            {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array)
    {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length)
        {
            var value = array[index];
            if (value)
            {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue)
    {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

    wrapTable: function()
    {
        $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
    },

    iframeReset: function()
    {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

        $iframeVideo.each(function()
        {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="rte__video-wrapper"></div>');
        });

        $iframeReset.each(function()
        {
            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};
slate.Sections = function Sections()
{
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor)
    {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined')
        {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt)
    {
        var container = $('[data-section-id]', evt.target)[0];
        if (container)
        {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance)
        {
            return;
        }

        if (typeof instance.onUnload === 'function')
        {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function')
        {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function')
        {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function')
        {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function')
        {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt)
    {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function')
        {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor)
    {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function(index, container)
        {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function()
{
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format)
    {
        if (typeof cents === 'string')
        {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal)
        {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null)
            {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1])
        {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function()
{

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size)
    {
        if (typeof images === 'string')
        {
            images = [images];
        }

        for (var i = 0; i < images.length; i++)
        {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path)
    {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src)
    {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match)
        {
            return match[1];
        } else
        {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size)
    {
        if (size === null)
        {
            return src;
        }

        if (size === 'master')
        {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match)
        {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else
        {
            return null;
        }
    }

    function removeProtocol(path)
    {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function()
{

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options)
    {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function()
        {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element)
            {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox')
                {
                    if ($element[0].checked)
                    {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else
                    {
                        return false;
                    }
                } else
                {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function()
        {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function(variant)
            {
                var satisfied = true;

                selectedValues.forEach(function(option)
                {
                    if (satisfied)
                    {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied)
                {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function()
        {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant)
            {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState)
            {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function(variant)
        {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src)
            {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function(variant)
        {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price)
            {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant sku changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantSKUChange
         */
        _updateSKU: function(variant)
        {
            if (variant.sku === this.currentVariant.sku)
            {
                return;
            }

            this.$container.trigger({
                type: 'variantSKUChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param  {variant} variant - Currently selected variant
         * @return {k}         [description]
         */
        _updateHistoryState: function(variant)
        {
            if (!history.replaceState || !variant)
            {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param  {variant} variant - Currently selected variant
         */
        _updateMasterSelect: function(variant)
        {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {
    /**
     * Turns a string into a handle. Mimics Shopify's format.
     */
    handleize: function(str)
    {
        return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },

    /**
     * Cross-browser URL query param getter
     */
    getQueryParams: function(qs)
    {
        qs = qs || document.location.search;

        if (!qs)
        {
            return;
        }

        qs = qs.split('+').join(' ');

        var params = {},
            tokens,
            re = /[?&]?([^=]+)=([^&]*)/g;

        while (tokens = re.exec(qs))
        {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }

        return params;
    },

    updateQueryStringParameter: function(key, value, url)
    {
        if (!url) url = window.location.href;

        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url))
        {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else
            {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        } else
        {
            if (typeof value !== 'undefined' && value !== null)
            {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    },

    // Returns content of template placed into snippets/js-tempales.liquid
    getTemplate: function(template)
    {
        return $('[data-template-for="' + template + '"]').html();
    },

    getYoutubeId: function(url)
    {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    },

    getProductJSON: function(handle, callback)
    {
        return $.get('/products/' + handle + '?view=json', null, callback, 'text');
    },

    flash: function(elements, color, duration)
    {
        var opacity = 100;
        var color = color || '255, 255, 136';
        var duration = duration || 2000;
        var interval = setInterval(function()
        {
            opacity -= 2.5;
            if (opacity <= 0)
            {
                clearInterval(interval);
                return;
            }
            $(elements).css({ background: "rgba(" + color + ", " + opacity / 100 + ")" });
        }, duration / 40);
    },

    // Gets the rendered size of an image using object-fit
    getRenderedImgSize: function(contains, cWidth, cHeight, width, height, pos)
    {
        var oRatio = width / height,
            cRatio = cWidth / cHeight;
        return function()
        {
            if (contains ? (oRatio > cRatio) : (oRatio < cRatio))
            {
                this.width = cWidth;
                this.height = cWidth / oRatio;
            } else
            {
                this.width = cHeight * oRatio;
                this.height = cHeight;
            }
            this.left = (cWidth - this.width) * (pos / 100);
            this.right = this.width + this.left;
            return this;
        }.call({});
    },

    // Returns size info for an image rendered with object-fit
    getImgSizeInfo: function(img)
    {
        var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
        return theme.utils.getRenderedImgSize(true,
            img.width,
            img.height,
            img.naturalWidth,
            img.naturalHeight,
            parseInt(pos[0]));
    },

    // Returns content of template placed into snippets/js-tempales.liquid
    getTemplate: function(template)
    {
        return $('[data-template-for="' + template + '"]').html();
    }

};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function()
{

    if (isMobile.any)
    {
        theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
            touchAction: 'auto',
            inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
            recognizers: [
                [Hammer.Swipe, {
                    direction: Hammer.DIRECTION_HORIZONTAL
                }]
            ]
        });

        theme.pageSwipeObject.on('swiperight', function(evt)
        {
            if ($('body').hasClass('js-drawer-open-right'))
            {
                var $drawer = $('.drawer.drawer--right');
                theme[$drawer.attr('id')].close();
                return;
            }

            var $drawer = $('.drawer.drawer--left');
            if (!$drawer.length)
            {
                return;
            }
            var delta_x = evt.deltaX;
            var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
            var startPosition = final_x - delta_x;
            if (startPosition >= 0 && startPosition <= 25)
            {
                theme[$drawer.attr('id')].open();
            }
            return false;
        });

        theme.pageSwipeObject.on('swipeleft', function(evt)
        {
            if ($('body').hasClass('js-drawer-open-left'))
            {
                var $drawer = $('.drawer.drawer--left');
                theme[$drawer.attr('id')].close();
                return;
            }

            var $drawer = $('.drawer.drawer--right');
            if (!$drawer.length)
            {
                return;
            }
            var delta_x = evt.deltaX;
            var final_x = evt.center.x || 0;
            var startPosition = final_x + -delta_x;
            var windowWidthOffset = $(window).width() - 25;
            if (startPosition >= windowWidthOffset)
            {
                theme[$drawer.attr('id')].open();
            }
            return false;
        });
    }

    function Drawer(id, position, options)
    {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };

        this.nodes = {
            $parent: $('html').add('body'),
            $page: $('#PageContent')
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $('#' + id);

        if (!this.$drawer.length)
        {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    }

    Drawer.prototype.init = function()
    {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    };

    Drawer.prototype.open = function(evt)
    {
        $('html').removeClass('js-rqf-open-right');
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt)
        {
            evt.preventDefault();
        } else
        {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to nodes.$page
        // which closes the drawer.
        if (evt && evt.stopPropagation)
        {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall)
        {
            return this.close();
        }


        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        this.$drawer.prepareTransition();

        this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;

        // Set focus on drawer
        slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });

        // Run function when draw opens if set
        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function')
        {
            if (!externalCall)
            {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded'))
        {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        this.bindEvents();

        return this;
    };

    Drawer.prototype.close = function()
    {
        if (!this.drawerIsOpen)
        { // don't close a closed drawer
            return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        // Ensure closing transition is applied to moved elements, like the nav
        this.$drawer.prepareTransition();

        this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

        this.drawerIsOpen = false;

        // Remove focus on drawer
        slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });

        this.unbindEvents();
    };

    Drawer.prototype.bindEvents = function()
    {
        this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt)
        {
            // close on 'esc' keypress
            if (evt.keyCode === 27)
            {
                this.close();
                return false;
            } else
            {
                return true;
            }
        }, this));

        // Lock scrolling on mobile
        // this.nodes.$page.on('touchmove.drawer', function() {
        //   return false;
        // });

        this.nodes.$page.on('click.drawer', $.proxy(function()
        {
            this.close();
            return false;
        }, this));
    };

    Drawer.prototype.unbindEvents = function()
    {
        this.nodes.$page.off('.drawer');
        this.nodes.$parent.off('.drawer');
    };

    return Drawer;
})();

/*============================================================================
  Modal modules
==============================================================================*/
theme.Modals = (function()
{
    function Modal(id, name, options)
    {
        var defaults = {
            close: '.js-modal-close',
            open: '.js-modal-open-' + name,
            openClass: 'modal--is-active'
        };

        this.$modal = $(id);

        if (!this.$modal.length)
        {
            return false;
        }

        this.nodes = {
            $parent: $('html').add('body')
        };
        this.config = $.extend(defaults, options);
        this.modalIsOpen = false;
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
        this.init();
    }

    Modal.prototype.init = function()
    {
        var $openBtn = $(this.config.open);

        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');

        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
    };

    Modal.prototype.open = function(evt)
    {
        // Keep track if modal was opened from a click, or called by another function
        var externalCall = false;

        // don't open an opened modal
        if (this.modalIsOpen)
        {
            return;
        }

        // Prevent following href if link is clicked
        if (evt)
        {
            evt.preventDefault();
        } else
        {
            externalCall = true;
        }

        // Without this, the modal opens, the click event bubbles up to $nodes.page
        // which closes the modal.
        if (evt && evt.stopPropagation)
        {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.modalIsOpen && !externalCall)
        {
            this.close();
        }

        this.$modal.addClass(this.config.openClass);
        this.nodes.$parent.addClass(this.config.openClass);

        this.modalIsOpen = true;

        // Set focus on modal
        slate.a11y.trapFocus({
            $container: this.$modal,
            $elementToFocus: this.$focusOnOpen,
            namespace: 'modal_focus'
        });

        if (this.$activeSource && this.$activeSource.attr('aria-expanded'))
        {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        this.bindEvents();
    };

    Modal.prototype.close = function()
    {
        // don't close a closed modal
        if (!this.modalIsOpen)
        {
            return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        this.$modal.removeClass(this.config.openClass);
        this.nodes.$parent.removeClass(this.config.openClass);

        this.modalIsOpen = false;

        // Remove focus on modal
        slate.a11y.removeTrapFocus({
            $container: this.$modal,
            namespace: 'modal_focus'
        });

        if (this.$activeSource && this.$activeSource.attr('aria-expanded'))
        {
            this.$activeSource.attr('aria-expanded', 'false').focus();
        }

        this.unbindEvents();
    };

    Modal.prototype.bindEvents = function()
    {
        // Pressing escape closes modal
        this.nodes.$parent.on('keyup.modal', $.proxy(function(evt)
        {
            if (evt.keyCode === 27)
            {
                this.close();
            }
        }, this));
    };

    Modal.prototype.unbindEvents = function()
    {
        this.nodes.$parent.off('.modal');
    };

    return Modal;
})();

window.theme = window.theme || {};

theme.Password = (function()
{
    var selectors = {
        passwordPage: '.password-page',
        loginModal: '#LoginModal',
        focusOnOpen: '#Password'
    };

    if (!$(selectors.passwordPage).length)
    {
        return;
    }

    initModal();

    function initModal()
    {
        var $loginModal = $(selectors.loginModal);

        if (!$loginModal.length)
        {
            return;
        }

        var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
            focusOnOpen: selectors.focusOnOpen
        });

        // Open modal if errors exist
        if ($loginModal.find('.errors').length)
        {
            passwordModal.open();
        }

    }
})();
(function()
{
    var selectors = {
        tabHandles: '.tabs-menu a'
    };

    var classes = {
        qtySelector: 'js-qty-select'
    };

    var $tabHandles = $(selectors.tabHandles);

    if (!$tabHandles.length)
    {
        return;
    }

    $(selectors.tabHandles).click(function(e)
    {
        e.preventDefault();
        var $this = $(this);
        $this.parent().addClass("current");
        $this.parent().siblings().removeClass("current");
        var tab = $this.attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
    });
})();

/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.QuantitySelectors = (function()
{
    var selectors = {
        qtyInputs: 'input[type="number"]',
        excludeInputs: '#cart input[type="number"], .js-qty-select input[type="number"]',
        qtySelector: '.js-qty-select',
        qtyButtonAdd: '.js-qty-select-add',
        qtyButtonSubtract: '.js-qty-select-sub',
    };

    var classes = {
        qtySelector: 'js-qty-select',
        qtyButtonAdd: 'js-qty-select-add',
        qtyButtonSubtract: 'js-qty-select-sub',
    };

    var $qtyInputs = $(selectors.qtyInputs).not(selectors.excludeInputs);

    if ($qtyInputs.length)
    {
        $qtyInputs.each(function()
        {
            var $el = $(this);
            init($el);
        });
    }

    $(document).on('click.qtySelector', selectors.qtySelector + ' button', function(evt)
    {
        evt.preventDefault();
        var $button = $(this);
        var $input = $button.siblings(selectors.qtyInputs);
        var oldValue = $input.val();
        var maxQty = parseInt($input.prop('max'));
        var minQty = parseInt($input.prop('min'));
        var newValue = minQty;

        if ($button.hasClass(classes.qtyButtonAdd))
        {
            newValue = parseFloat(oldValue) + 1;
            if (maxQty && newValue >= maxQty)
            {
                $button.prop('disabled', true);
            }
        } else
        {
            if (oldValue > minQty)
            {
                newValue = parseFloat(oldValue) - 1;
                if (maxQty && newValue < maxQty)
                {
                    $button.siblings(selectors.qtyButtonAdd).prop('disabled', false);
                }
            }
        }

        $input.val(newValue);
        $input.trigger('update.qtySelector');
        $input.trigger('change');
    });

    function init($el)
    {
        if (!$el.length)
        {
            return false;
        }

        var $wrapper = $el.wrap('<div class="' + classes.qtySelector + '"></div>').parent();
        var value = parseInt($el.val());
        var maxQty = parseInt($el.prop('max'));

        $wrapper.prepend('<button class="' + classes.qtyButtonSubtract + '">-</button>');

        if (maxQty == 1 && value == 1)
        {
            $wrapper.append('<button class="' + classes.qtyButtonAdd + '" disabled>+</button>');
        } else
        {
            $wrapper.append('<button class="' + classes.qtyButtonAdd + '">+</button>');
        }
    }

    return {
        init: init
    };
})();

(function()
{
    var classes = {
        notificationHidden: 'notification-message--hidden'
    };

    var queryParams = theme.utils.getQueryParams();

    if (queryParams === undefined || queryParams.status === undefined)
    {
        return;
    }

    $('[data-notification="' + queryParams.status + '"]').removeClass(classes.notificationHidden);

})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined')
{
    var Currency = {};
}

Currency.cookie = {
    configuration: {
        expires: 365,
        path: '/',
        domain: window.location.hostname
    },
    name: 'currency',
    write: function(currency)
    {
        jQuery.cookie(this.name, currency, this.configuration);
    },
    read: function()
    {
        return jQuery.cookie(this.name);
    },
    destroy: function()
    {
        jQuery.cookie(this.name, null, this.configuration);
    }
};

Currency.moneyFormats = {
    "USD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} USD"
    },
    "EUR": {
        "money_format": "&euro;{{amount}}",
        "money_with_currency_format": "&euro;{{amount}} EUR"
    },
    "GBP": {
        "money_format": "&pound;{{amount}}",
        "money_with_currency_format": "&pound;{{amount}} GBP"
    },
    "CAD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} CAD"
    },
    "ALL": {
        "money_format": "Lek {{amount}}",
        "money_with_currency_format": "Lek {{amount}} ALL"
    },
    "DZD": {
        "money_format": "DA {{amount}}",
        "money_with_currency_format": "DA {{amount}} DZD"
    },
    "AOA": {
        "money_format": "Kz{{amount}}",
        "money_with_currency_format": "Kz{{amount}} AOA"
    },
    "ARS": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
    },
    "AMD": {
        "money_format": "{{amount}} AMD",
        "money_with_currency_format": "{{amount}} AMD"
    },
    "AWG": {
        "money_format": "Afl{{amount}}",
        "money_with_currency_format": "Afl{{amount}} AWG"
    },
    "AUD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} AUD"
    },
    "BBD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} Bds"
    },
    "AZN": {
        "money_format": "m.{{amount}}",
        "money_with_currency_format": "m.{{amount}} AZN"
    },
    "BDT": {
        "money_format": "Tk {{amount}}",
        "money_with_currency_format": "Tk {{amount}} BDT"
    },
    "BSD": {
        "money_format": "BS${{amount}}",
        "money_with_currency_format": "BS${{amount}} BSD"
    },
    "BHD": {
        "money_format": "{{amount}}0 BD",
        "money_with_currency_format": "{{amount}}0 BHD"
    },
    "BYR": {
        "money_format": "Br {{amount}}",
        "money_with_currency_format": "Br {{amount}} BYR"
    },
    "BZD": {
        "money_format": "BZ${{amount}}",
        "money_with_currency_format": "BZ${{amount}} BZD"
    },
    "BTN": {
        "money_format": "Nu {{amount}}",
        "money_with_currency_format": "Nu {{amount}} BTN"
    },
    "BAM": {
        "money_format": "KM {{amount_with_comma_separator}}",
        "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
    },
    "BRL": {
        "money_format": "R$ {{amount_with_comma_separator}}",
        "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
    },
    "BOB": {
        "money_format": "Bs{{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
    },
    "BWP": {
        "money_format": "P{{amount}}",
        "money_with_currency_format": "P{{amount}} BWP"
    },
    "BND": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} BND"
    },
    "BGN": {
        "money_format": "{{amount}} лв",
        "money_with_currency_format": "{{amount}} лв BGN"
    },
    "MMK": {
        "money_format": "K{{amount}}",
        "money_with_currency_format": "K{{amount}} MMK"
    },
    "KHR": {
        "money_format": "KHR{{amount}}",
        "money_with_currency_format": "KHR{{amount}}"
    },
    "KYD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} KYD"
    },
    "XAF": {
        "money_format": "FCFA{{amount}}",
        "money_with_currency_format": "FCFA{{amount}} XAF"
    },
    "CLP": {
        "money_format": "${{amount_no_decimals}}",
        "money_with_currency_format": "${{amount_no_decimals}} CLP"
    },
    "CNY": {
        "money_format": "&#165;{{amount}}",
        "money_with_currency_format": "&#165;{{amount}} CNY"
    },
    "COP": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} COP"
    },
    "CRC": {
        "money_format": "&#8353; {{amount_with_comma_separator}}",
        "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
    },
    "HRK": {
        "money_format": "{{amount_with_comma_separator}} kn",
        "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
    },
    "CZK": {
        "money_format": "{{amount_with_comma_separator}} K&#269;",
        "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
    },
    "DKK": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
    },
    "DOP": {
        "money_format": "RD$ {{amount}}",
        "money_with_currency_format": "RD$ {{amount}}"
    },
    "XCD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "EC${{amount}}"
    },
    "EGP": {
        "money_format": "LE {{amount}}",
        "money_with_currency_format": "LE {{amount}} EGP"
    },
    "ETB": {
        "money_format": "Br{{amount}}",
        "money_with_currency_format": "Br{{amount}} ETB"
    },
    "XPF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    "FJD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "FJ${{amount}}"
    },
    "GMD": {
        "money_format": "D {{amount}}",
        "money_with_currency_format": "D {{amount}} GMD"
    },
    "GHS": {
        "money_format": "GH&#8373;{{amount}}",
        "money_with_currency_format": "GH&#8373;{{amount}}"
    },
    "GTQ": {
        "money_format": "Q{{amount}}",
        "money_with_currency_format": "{{amount}} GTQ"
    },
    "GYD": {
        "money_format": "G${{amount}}",
        "money_with_currency_format": "${{amount}} GYD"
    },
    "GEL": {
        "money_format": "{{amount}} GEL",
        "money_with_currency_format": "{{amount}} GEL"
    },
    "HNL": {
        "money_format": "L {{amount}}",
        "money_with_currency_format": "L {{amount}} HNL"
    },
    "HKD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "HK${{amount}}"
    },
    "HUF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    "ISK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
    },
    "INR": {
        "money_format": "Rs. {{amount}}",
        "money_with_currency_format": "Rs. {{amount}}"
    },
    "IDR": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
    },
    "ILS": {
        "money_format": "{{amount}} NIS",
        "money_with_currency_format": "{{amount}} NIS"
    },
    "JMD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} JMD"
    },
    "JPY": {
        "money_format": "&#165;{{amount_no_decimals}}",
        "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
    },
    "JEP": {
        "money_format": "&pound;{{amount}}",
        "money_with_currency_format": "&pound;{{amount}} JEP"
    },
    "JOD": {
        "money_format": "{{amount}}0 JD",
        "money_with_currency_format": "{{amount}}0 JOD"
    },
    "KZT": {
        "money_format": "{{amount}} KZT",
        "money_with_currency_format": "{{amount}} KZT"
    },
    "KES": {
        "money_format": "KSh{{amount}}",
        "money_with_currency_format": "KSh{{amount}}"
    },
    "KWD": {
        "money_format": "{{amount}}0 KD",
        "money_with_currency_format": "{{amount}}0 KWD"
    },
    "KGS": {
        "money_format": "лв{{amount}}",
        "money_with_currency_format": "лв{{amount}}"
    },
    "LVL": {
        "money_format": "Ls {{amount}}",
        "money_with_currency_format": "Ls {{amount}} LVL"
    },
    "LBP": {
        "money_format": "L&pound;{{amount}}",
        "money_with_currency_format": "L&pound;{{amount}} LBP"
    },
    "LTL": {
        "money_format": "{{amount}} Lt",
        "money_with_currency_format": "{{amount}} Lt"
    },
    "MGA": {
        "money_format": "Ar {{amount}}",
        "money_with_currency_format": "Ar {{amount}} MGA"
    },
    "MKD": {
        "money_format": "ден {{amount}}",
        "money_with_currency_format": "ден {{amount}} MKD"
    },
    "MOP": {
        "money_format": "MOP${{amount}}",
        "money_with_currency_format": "MOP${{amount}}"
    },
    "MVR": {
        "money_format": "Rf{{amount}}",
        "money_with_currency_format": "Rf{{amount}} MRf"
    },
    "MXN": {
        "money_format": "$ {{amount}}",
        "money_with_currency_format": "$ {{amount}} MXN"
    },
    "MYR": {
        "money_format": "RM{{amount}} MYR",
        "money_with_currency_format": "RM{{amount}} MYR"
    },
    "MUR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} MUR"
    },
    "MDL": {
        "money_format": "{{amount}} MDL",
        "money_with_currency_format": "{{amount}} MDL"
    },
    "MAD": {
        "money_format": "{{amount}} dh",
        "money_with_currency_format": "Dh {{amount}} MAD"
    },
    "MNT": {
        "money_format": "{{amount_no_decimals}} &#8366",
        "money_with_currency_format": "{{amount_no_decimals}} MNT"
    },
    "MZN": {
        "money_format": "{{amount}} Mt",
        "money_with_currency_format": "Mt {{amount}} MZN"
    },
    "NAD": {
        "money_format": "N${{amount}}",
        "money_with_currency_format": "N${{amount}} NAD"
    },
    "NPR": {
        "money_format": "Rs{{amount}}",
        "money_with_currency_format": "Rs{{amount}} NPR"
    },
    "ANG": {
        "money_format": "&fnof;{{amount}}",
        "money_with_currency_format": "{{amount}} NA&fnof;"
    },
    "NZD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} NZD"
    },
    "NIO": {
        "money_format": "C${{amount}}",
        "money_with_currency_format": "C${{amount}} NIO"
    },
    "NGN": {
        "money_format": "&#8358;{{amount}}",
        "money_with_currency_format": "&#8358;{{amount}} NGN"
    },
    "NOK": {
        "money_format": "kr {{amount_with_comma_separator}}",
        "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
    },
    "OMR": {
        "money_format": "{{amount_with_comma_separator}} OMR",
        "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
    },
    "PKR": {
        "money_format": "Rs.{{amount}}",
        "money_with_currency_format": "Rs.{{amount}} PKR"
    },
    "PGK": {
        "money_format": "K {{amount}}",
        "money_with_currency_format": "K {{amount}} PGK"
    },
    "PYG": {
        "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    "PEN": {
        "money_format": "S/. {{amount}}",
        "money_with_currency_format": "S/. {{amount}} PEN"
    },
    "PHP": {
        "money_format": "&#8369;{{amount}}",
        "money_with_currency_format": "&#8369;{{amount}} PHP"
    },
    "PLN": {
        "money_format": "{{amount_with_comma_separator}} zl",
        "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
    },
    "QAR": {
        "money_format": "QAR {{amount_with_comma_separator}}",
        "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
    },
    "RON": {
        "money_format": "{{amount_with_comma_separator}} lei",
        "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
    },
    "RUB": {
        "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    "RWF": {
        "money_format": "{{amount_no_decimals}} RF",
        "money_with_currency_format": "{{amount_no_decimals}} RWF"
    },
    "WST": {
        "money_format": "WS$ {{amount}}",
        "money_with_currency_format": "WS$ {{amount}} WST"
    },
    "SAR": {
        "money_format": "{{amount}} SR",
        "money_with_currency_format": "{{amount}} SAR"
    },
    "STD": {
        "money_format": "Db {{amount}}",
        "money_with_currency_format": "Db {{amount}} STD"
    },
    "RSD": {
        "money_format": "{{amount}} RSD",
        "money_with_currency_format": "{{amount}} RSD"
    },
    "SCR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} SCR"
    },
    "SGD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} SGD"
    },
    "SYP": {
        "money_format": "S&pound;{{amount}}",
        "money_with_currency_format": "S&pound;{{amount}} SYP"
    },
    "ZAR": {
        "money_format": "R {{amount}}",
        "money_with_currency_format": "R {{amount}} ZAR"
    },
    "KRW": {
        "money_format": "&#8361;{{amount_no_decimals}}",
        "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
    },
    "LKR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} LKR"
    },
    "SEK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
    },
    "CHF": {
        "money_format": "SFr. {{amount}}",
        "money_with_currency_format": "SFr. {{amount}} CHF"
    },
    "TWD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TWD"
    },
    "THB": {
        "money_format": "{{amount}} &#xe3f;",
        "money_with_currency_format": "{{amount}} &#xe3f; THB"
    },
    "TZS": {
        "money_format": "{{amount}} TZS",
        "money_with_currency_format": "{{amount}} TZS"
    },
    "TTD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TTD"
    },
    "TND": {
        "money_format": "{{amount}}",
        "money_with_currency_format": "{{amount}} DT"
    },
    "TRY": {
        "money_format": "{{amount}}TL",
        "money_with_currency_format": "{{amount}}TL"
    },
    "UGX": {
        "money_format": "Ush {{amount_no_decimals}}",
        "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
    },
    "UAH": {
        "money_format": "₴{{amount}}",
        "money_with_currency_format": "₴{{amount}} UAH"
    },
    "AED": {
        "money_format": "Dhs. {{amount}}",
        "money_with_currency_format": "Dhs. {{amount}} AED"
    },
    "UYU": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
    },
    "VUV": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}}VT"
    },
    "VEF": {
        "money_format": "Bs. {{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
    },
    "VND": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
    },
    "XBT": {
        "money_format": "{{amount_no_decimals}} BTC",
        "money_with_currency_format": "{{amount_no_decimals}} BTC"
    },
    "XOF": {
        "money_format": "CFA{{amount}}",
        "money_with_currency_format": "CFA{{amount}} XOF"
    },
    "ZMW": {
        "money_format": "K{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
};

Currency.formatMoney = function(cents, format)
{
    if (typeof Shopify.formatMoney === 'function')
    {
        return Shopify.formatMoney(cents, format);
    }
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function defaultOption(opt, def)
    {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal)
    {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) { return 0; }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1])
    {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format)
{
    if (newCurrency === undefined)
    {
        return;
    }

    $(selector || 'span.money').each(function()
    {
        // If the amount has already been converted, we leave it alone.
        if ($(this).attr('data-currency') === newCurrency) return;
        // If we are converting to a currency that we have saved, we will use the saved amount.
        if ($(this).attr('data-currency-' + newCurrency))
        {
            $(this).html($(this).attr('data-currency-' + newCurrency));
        }
        else
        {
            // Converting to Y for the first time? Let's get to it!
            var cents = 0.0;
            var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
            var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
            if (oldFormat.indexOf('amount_no_decimals') !== -1)
            {
                cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) * 100, oldCurrency, newCurrency);
            }
            else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD')
            {
                cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) / 10, oldCurrency, newCurrency);
            }
            else
            {
                cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
            }
            var newFormattedAmount = Currency.formatMoney(cents, newFormat);
            $(this).html(newFormattedAmount);
            $(this).attr('data-currency-' + newCurrency, newFormattedAmount);
        }
        // We record the new currency locally.
        $(this).attr('data-currency', newCurrency);
    });
    this.currentFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
    this.currentCurrency = newCurrency;
    this.cookie.write(newCurrency);
};

(function()
{

    $('.ui.accordion').accordion();

})();

theme.animationQueueProcessing = false;
theme.animationQueue = [];

theme.processAnimationQueue = function()
{

    if (theme.animationQueue.length)
    {

        theme.animationQueueProcessing = true;
        var event = theme.animationQueue.shift();
        var eventElement = event.element;
        var eventDelay = event.delay || 0;
        var eventDuration = event.duration || 500;
        var animation = theme.animations.library[event.animationType];

        if (!animation)
        {
            console.error('No animation found');
            return;
        }

        animation = _.extend(animation, {
            targets: eventElement,
            duration: eventDuration
        });

        anime(animation);

        // event.$element.transition({
        //   animation: event.type,
        //   duration: event.duration,
        // });

        window.setTimeout(function()
        {
            theme.processAnimationQueue();
        }, eventDelay);

    } else
    {
        theme.animationQueueProcessing = false;
    }

};

theme.animations = (function()
{

    var self = this;

    this.library = {

        fadeInUp: {
            easing: 'easeOutQuad',
            opacity: [0, 1],
            translateY: ['10%', 0]
        },

        fadeInCenter: {
            easing: 'easeOutQuad',
            opacity: [0, 1],
            translateY: ['-40%', '-50%']
        }

    };

    this.bind = function(el)
    {

        var exludeSelectors = '.bc-sf-filter-product-item:nth-child(1), .bc-sf-filter-product-item:nth-child(2), .bc-sf-filter-product-item:nth-child(3), .bc-sf-filter-product-item:nth-child(4), .bc-sf-filter-product-item:nth-child(5), .bc-sf-filter-product-item:nth-child(6), .bc-sf-filter-product-item:nth-child(7), .bc-sf-filter-product-item:nth-child(8)';

        var $animationElements = el ? $(el) : $('[data-animate]:not(' + exludeSelectors + ')');

        var $excludedElements = $(exludeSelectors);
        $excludedElements.removeAttr('data-animate');

        $animationElements.each(function()
        {

            var $el = $(this);

            if ($el.data('animationReady'))
            {
                return;
            }

            var animationType = $el.data('animate') || 'fadeInUp';
            var animationDuration = $el.data('duration') || 0;
            var animationDelay = $el.data('delay') || 100;
            var animationOffset = ($el.data('offset') || 60) + '%';

            $el.attr('data-animation-ready', true);

            var $img = $('img.lazyload', $el).first();

            if ($img.length && !isMobile.any)
            {
                $img.one('lazyloaded.animate', bindWaypoint);
            } else
            {
                bindWaypoint();
            }

            function bindWaypoint()
            {

                $el.waypoint({

                    handler: function(direction)
                    {

                        // Check image has loaded - lazyload callback: data-animate-image=[selector] (if no selector, find first image)
                        // if loaded, execute. If not add onload listener

                        var waypoint = this;

                        setTimeout(function()
                        {

                            // if ($el.is(':visible')) {

                            // Once
                            waypoint.destroy();

                            theme.animationQueue.push({
                                element: $el.get(),
                                animationType: animationType,
                                duration: animationDuration,
                                delay: animationDelay,
                            });

                            self.animate();
                            // }

                        }, 100);
                    },

                    offset: animationOffset,
                });
            }

        });
    };

    this.animate = function()
    {

        if (!theme.animationQueueProcessing)
        {
            theme.processAnimationQueue();
        }
    };

    this.bind();

    return {
        library: this.library,
        bind: this.bind
    };

})();
theme.prices = (function()
{

    var selectors = {
        priceWithoutTax: '[data-price-without-tax]',
        priceWithTax: '[data-price-with-tax]'
    };

    var defaults = {
        visitingCountry: 'AU'
    };

    var cache = {};

    function updatePrice(el)
    {

        var $el = (el ? $(el) : $(selectors.priceWithoutTax));

        if (!shop.customer.visitingCountry && !cache.geoIPLookupPerformed)
        {
            getLocation();
        }

        var visitingCountry = shop.customer.visitingCountry ? shop.customer.visitingCountry : defaults.visitingCountry;

        $el.each(function(index, priceElement)
        {
            var $priceElement = $(priceElement);
            var priceWithoutTax = $priceElement.data('priceWithoutTax');
            var priceWithTax = (getPriceWithTax(priceWithoutTax) / 100).toFixed(2);
            priceWithTax = shop.moneyWithCurrencyFormat.replace('{{amount}}', priceWithTax);
            $priceElement.html(priceWithTax.replace('.00', ''));
        });

    }

    function setCountryCode(countryCode)
    {
        shop.customer.visitingCountry = countryCode;
        sessionStorage.setItem('visitingCountry', countryCode);
    }

    function getLocation()
    {

        cache.geoIPLookupPerformed = true;

        var countryFromStorage = sessionStorage.getItem('visitingCountry');

        if (countryFromStorage)
        {
            setCountryCode(countryFromStorage);
            updatePrice();
            return;
        }

        var onSuccess = function(location)
        {
            try
            {
                var visitingCountry = location.country.iso_code;
                setCountryCode(visitingCountry);
                updatePrice();
            } catch (err)
            {
                onError(error);
            }
        };

        var onError = function(error)
        {
            // setCountryCode(defaults.visitingCountry);
            setCountryCode(defaults.visitingCountry);
            updatePrice();
        };

        geoip2.country(onSuccess, onError);

    }

    function getPriceWithTax(price, quantity)
    {

        var visitingCountry,
            singleItemPrice,
            lowPricedItemThreshold = 2000;

        visitingCountry = shop.customer.visitingCountry ? shop.customer.visitingCountry : defaults.visitingCountry;

        if (visitingCountry == 'AU')
        {

            if (quantity && quantity > 1)
            {
                singleItemPrice = price / quantity;
            }

            if (price < lowPricedItemThreshold || (typeof singleItemPrice == 'integer' && singleItemPrice < lowPricedItemThreshold))
            {

                price = price * 1.099;

                // Round to closest cent
                price = Math.round(price);

            } else
            {

                // 10% TAX
                price = price * 1.1;

                // Round to closest 5 cents
                price = Math.round(price / 5) * 5;


            }



        } else if (visitingCountry == 'UK')
        {

            if (quantity && quantity > 1)
            {
                singleItemPrice = price / quantity;
            }

            if (price < lowPricedItemThreshold || (typeof singleItemPrice == 'integer' && singleItemPrice < lowPricedItemThreshold))
            {

                price = price * 1.2;

                // Round to closest cent
                price = Math.round(price);

            } else
            {

                // 10% TAX
                price = price * 1.2;

                // Round to closest 5 cents
                price = Math.round(price / 5) * 5;


            }



        }

        return price;

    }

    return {

        updatePrice: updatePrice,
        setCountryCode: setCountryCode,
        getPriceWithTax: getPriceWithTax

    };

})();


/*================ Modules ================*/
window.theme = window.theme || {};

theme.dispatch = (function()
{
    if (!window.shop.dispatch)
    {
        return;
    }

    var $document = $(document);

    $document.on('cart.ready', function(event, cart)
    {
        window.shop.dispatch.date = calculateDispatchDate();
    });

    $document.on('cart.requestComplete', function(event, cart)
    {
        window.shop.dispatch.date = calculateDispatchDate();
    });

    function addDays(date, days)
    {
        //https://stackoverflow.com/a/47436839
        var oneDay = 1000 * 60 * 60 * 24;
        return new Date(date.getTime() + (days * oneDay));
    }

    function checkValid(dispatchDate)
    {
        var validDispatchDays = [1, 2, 3, 4, 5];
        var dispatchDay = dispatchDate.getDay();
        return (validDispatchDays.indexOf(dispatchDay) > -1);
    }

    function calculateDispatchDate()
    {
        var now = new Date();
        var currentHour = now.getHours();
        var daysToDispatch = window.shop.dispatch.days_to_dispatch;
        var cutoffHour = window.shop.dispatch.dispatch_cutoff_hour;
        var dispatchDate;
        var dispatchDayValid;

        // Same day cutoff
        if (daysToDispatch == 0 && cutoffHour <= currentHour)
        {
            daysToDispatch += 1;
        }

        dispatchDate = addDays(now, daysToDispatch);
        dispatchDayValid = checkValid(dispatchDate);

        var i = 0;
        while (!dispatchDayValid && i < 7)
        {
            dispatchDate = addDays(dispatchDate, 1);
            dispatchDayValid = checkValid(dispatchDate);
        }

        return dispatchDate;
    }

})();

window.theme = window.theme || {};

theme.NoticeBar = (function()
{

    var selectors = {
        slideshow: '[data-slideshow]'
    };


    function NoticeBar(container)
    {

        this.$container = $(container);
        this.$slideshows = $(selectors.slideshow, this.$container);

        $.each(this.$slideshows, function(index, slideshow)
        {

            theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

        });

    }

    return NoticeBar;
})();

window.theme = window.theme || {};

theme.Brands = (function()
{

    var selectors = {
        slideshow: '[data-slideshow]'
    }


    function Brands(container)
    {

        this.$container = $(container);
        this.$slideshows = $(selectors.slideshow, this.$container);

        $.each(this.$slideshows, function(index, slideshow)
        {

            theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

        });



    }

    return Brands;
})();


window.theme = window.theme || {};

theme.LandingPageFeaturedCollection = (function()
{
    var config = {
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        slideCount: 0
    };

    var sliderOptions = {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
    };

    function LandingPageFeaturedCollection(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var wrapper = this.wrapper = '.featured-collection-wrap';
        var slider = this.slider = '#featured-collection-' + sectionId;
        var $slider = $(slider, wrapper);
        var sliderActive = false;

        var options = $.extend({}, sliderOptions, {
            prevArrow: slider + ' ~ .featured-collection__prev',
            nextArrow: slider + ' ~ .featured-collection__next',
            autoplay: $slider.data('autoplay'),
            autoplaySpeed: $slider.data('speed'),
            responsive: [
                {
                    breakpoint: 1480,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        // dots: true,
                        autoplay: $slider.data('autoplay-mobile'),
                    }
                },
                {
                    breakpoint: 512,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        // dots: true
                    }
                }
            ]
        });

        $slider.on('init', this.a11y.bind(this));

        initSlider($slider, options);

        function initSlider(sliderObj, args)
        {
            if (sliderActive)
            {
                sliderObj.slick('unslick');
                sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;

            $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each(function()
            {
                var $el = $(this);
                theme.QuantitySelectors.init($el);
            });
        }


        $('.product-finish').each(function()
        {
            var $el = $(this);
            var color = $el.attr('data-finish');
            var data = JSON.parse($('#product-finish-data').html());

            if (data.some(function(x)
            {
                return x.tag === color;
            }))
            {
                var colorData = data.filter(function(x)
                {
                    return x.tag === color;
                });
                var colorName = colorData[0].title;
                var colorStyle = colorData[0].style;
                $el.css("background", colorStyle);
                var parent = $el.parent();
                parent.find('.product-finish-label').text(colorName);
            }
        });

    }

    LandingPageFeaturedCollection.prototype = _.assignIn({}, LandingPageFeaturedCollection.prototype, {
        onUnload: function()
        {
            $(this.slider, this.wrapper).slick('unslick');
        },

        a11y: function(event, obj)
        {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);

            // Remove default Slick aria-live attr until slider is focused
            $list.removeAttr('aria-live');

            // When an element in the slider is focused set aria-live
            $wrapper.on('focusin', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.attr('aria-live', 'polite');
                }
            });

            // Remove aria-live
            $wrapper.on('focusout', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return LandingPageFeaturedCollection;
})();

window.theme = window.theme || {};

theme.AjaxCart = (function()
{
    var selectors = {
        addToCartBtn: '[type="submit"]',
        addToCartForm: 'form[action="/cart/add"]',
        cartCount: '.site-header__cart',
        cartToggle: '.cart__toggle',
        cartDrawer: '.cart-drawer',
        cartDrawerOpen: '.cart-drawer--open'
    };

    var settings = {
        // 'aboveForm' for top of add to cart form,
        // 'belowForm' for below the add to cart form,
        // 'nextButton' for next to add to cart button and
        // 'afterBody' for after the main body content (used for fixed notifications).
        feedbackPosition: 'afterBody'
    };

    var options = {
        requestBodyClass: 'cart-loading',
        moneyFormat: window.shop.moneyFormat,
        moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
        weightUnit: 'kg', // g, kg, oz, lb
        weightPrecision: 0,
        tinybindModels: {
            'customer': window.shop.customer,
            'dispatch': window.shop.dispatch
        }
    };

    var cache = {
        previousCartItems: [],
        updatedItems: []
    };

    function init()
    {
        if (!$(selectors.cartDrawer).length)
        {
            return;
        }

        tinybind.formatters.replace = function(value, search, replace)
        {
            return value.replace(search, replace);
        }

        tinybind.formatters.replaceWith = function(a, b)
        {
            return b;
        }

        tinybind.formatters.handle = function(string)
        {
            return theme.utils.handleize(string);
        }

        tinybind.formatters.startsWith = function(value, prefix)
        {
            return value.indexOf(prefix) === 0;
        }

        tinybind.formatters.endsWith = function(value, suffix)
        {
            return value.indexOf(suffix, value.length - suffix.length) !== -1;
        }

        tinybind.binders.selected = function(el, value)
        {
            if (value)
            {
                el.selected = 'selected';
            }
        };

        $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function()
        {
            var $this = $(this);
            var progressElementSelector = $this.data('progress-element');
            var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;

            if (!$this.is('.disabled'))
            {
                if ($progressElement.length)
                {
                    $progressElement.addClass('cart-loader loading');
                }

                if ($this.is('[data-opens-cart-drawer]'))
                {
                    $('body').addClass('cart-loading--opens-drawer');
                }
            } else
            {
                evt.preventDefault();
                evt.stopPropagation();

                $progressElement.addClass('error');
                window.setTimeout(function()
                {
                    $progressElement.removeClass('error');
                }, 1500);

                var highlightElements = $this.data('enable-requirements');
                if (highlightElements)
                {
                    theme.utils.flash(highlightElements);
                }
            }
        });

        initDrawer();

        // Override CartJS error handling
        // Uses extra code from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
        CartJS.errorHandling = {
            cartError: function(error)
            {
                $('.cart-loader.loading').removeClass('loading');
                showFeedback('error', error.description);
            }
        };

        CartJS.init(window.shop.cart, options);

        $('.cart-drawer__submit').click(function()
        {
            $(document.body).addClass('checkout-activated');
        });

        $(document).on('cart.requestStarted', function(event, cart)
        {
            cache.previousCartItems = cart.items;

            if ('NProgress' in window)
            {
                NProgress.start();
            }
        });

        $(document).on('cart.requestComplete', function(event, cart)
        {
            if ('NProgress' in window)
            {
                NProgress.done();
            }

            $('.cart-loader.loading').removeClass('loading');

            cache.updatedItems = _.differenceWith(cache.previousCartItems, cart.items, _.isEqual);

            shop.cart = cart;

            if (theme.Favicon !== undefined)
            {
                if (cart.item_count > 0)
                {
                    theme.Favicon.set(cart.item_count);
                } else
                {
                    theme.Favicon.reset();
                }
            }

            var opensDrawer = $('body').is('.cart-loading--opens-drawer');

            if (opensDrawer !== undefined && opensDrawer)
            {
                if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false)
                {
                    if (!theme.CartDrawer.drawerIsOpen)
                    {
                        $('body').removeClass('cart-loading--opens-drawer');
                        theme.CartDrawer.open();
                    }
                }
            }

            if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1)
            {
                window.setTimeout(function()
                {
                    theme.CartDrawer.close();
                }, 2500);
            }


            for (let a = 0; a < cache.updatedItems.length; a++)
            {
                let wasRemoved = true;
                for (let b = 0; b < cart.items.length; b++)
                {
                    if (cache.updatedItems[a].id == cart.items[b].id)
                    {
                        wasRemoved = false;
                    }
                }

                if (wasRemoved)
                {
                    let element = $('.product-lower[data-product="' + cache.updatedItems[a].id + '"');
                    element.removeClass("active");
                }
            }
        });
    }

    function initDrawer()
    {
        $('#MainContent').addClass('drawer-page-content');
        $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

        theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
            onDrawerOpen: cartDrawerOpen
        });
    }

    function cartDrawerOpen()
    {
        // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
    }

    function cartDrawerClose()
    {
        // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
    }

    function showFeedback(status, response, $addToCartForm)
    {
        $('.ajax-cart-feedback').remove();
        var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';

        if ($addToCartForm !== undefined && $addToCartForm.length > 0)
        {
            switch (settings.feedbackPosition)
            {
                case 'aboveForm':
                    $addToCartForm.before(feedback);
                    break;
                case 'belowForm':
                    $addToCartForm.after(feedback);
                    break;
                case 'afterBody':
                    $(document.body).append(feedback);
                    break;
                case 'nextButton':
                default:
                    $addToCartForm.find(selectors.addToCartBtn).after(feedback);
                    break;
            }
        } else
        {
            iziToast.show({
                message: response,
                color: 'red',
                position: 'bottomCenter'
            });
        }

        var $feedbackElement = $('.ajax-cart-feedback');

        $feedbackElement.offset(); // redraw
        $feedbackElement.addClass('active');
        window.setTimeout(function()
        {
            $feedbackElement.removeClass('active');
        }, 6500);
    };

    return {
        init: init
    };
})();

theme.AjaxCart.init();

theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function()
{
    // If there's something in the queue, process it
    if (theme.cartQueue.length)
    {
        theme.cartQueueProcessing = true;
        var request = theme.cartQueue.shift();
        var requestType = request.type || 'add';

        if (requestType == 'add')
        {
            CartJS.addItem(request.variant_id, request.quantity, request.properties, {
                "success": function(data, textStatus, jqXHR)
                {
                    theme.processCartQueue();
                }
            });
        } else if (requestType == 'update')
        {
            CartJS.updateItem(line_number, quantity, properties = {}, options = {})
        } else
        {
            // CartJS.removeItem(line_number, options = {})
        }


        ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
    }
    else
    {
        theme.cartQueueProcessing = false;
    }
};
window.theme = window.theme || {};

theme.Header = (function()
{
    var selectors = {
        body: 'body',
        navigation: '.site-nav',
        siteNavHasDropdown: '.site-nav--has-dropdown',
        siteNavChildLinks: '.site-nav__child-link, .site-nav__grandchild-link, .site-nav__childlist-footer .btn',
        siteNavActiveDropdown: '.site-nav--active-dropdown',
        siteNavLinkMain: '.site-nav__link--main',
        siteNavChildLink: '.site-nav__link--last',
        siteNavChildLinkWithChildren: '.site-nav__child-link--parent',
    };

    var config = {
        hoverClass: 'site-nav--hover',
        activeClass: 'site-nav--active-dropdown',
        childLinkClass: 'site-nav__child-link',
        submenuVisibleOnHover: true,
        firstParentClickNavigates: true, // Overridden for mobile devices
        secondParentClickClosesSubmenu: false, // Relies on previous option being disabled for non-mobile devices
    };

    var cache = {
        isMobile: isMobile.any
    };

    function init()
    {
        cacheSelectors();

        if (config.submenuVisibleOnHover && cache.isMobile == false)
        {
            cache.$parents.on('mouseenter.siteNav', function(evt)
            {
                var $el = $(this);
                showDropdown($el);
            });

            cache.$parents.on('mouseleave.siteNav', function(evt)
            {
                var $el = $(this);
                hideDropdown($el);
            });
        }

        if (cache.$nav.is('[data-disable-parent-navigation]'))
        {
            // Override standard click events
            cache.$childLinksWithChildren.on('click.siteNav', function(evt)
            {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            });
            config.firstParentClickNavigates = false;
            config.secondParentClickClosesSubmenu = true;
        }

        cache.$parents.on('click.siteNav', function(evt)
        {
            var $el = $(this);

            if (config.firstParentClickNavigates && cache.isMobile == false)
            {
                return;
            }

            if (config.secondParentClickClosesSubmenu || !config.secondParentClickClosesSubmenu && !$el.hasClass(config.activeClass))
            {
                // force stop the click from happening
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }

            if (config.secondParentClickClosesSubmenu && $el.hasClass(config.activeClass))
            {
                hideDropdown($el);
                return;
            }

            showDropdown($el);
        });

        // check when we're leaving a dropdown and close the active dropdown
        $(selectors.siteNavChildLink).on('focusout.siteNav', function()
        {
            setTimeout(function()
            {
                if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length)
                {
                    return;
                }

                hideDropdown(cache.$activeDropdown);
            }, 5000);
        });

        // close dropdowns when on top level nav
        cache.$topLevel.on('focus.siteNav', function()
        {
            if (cache.$activeDropdown.length)
            {
                hideDropdown(cache.$activeDropdown);
            }
        });

        cache.$subMenuLinks.on('click.siteNav', function(evt)
        {
            // Prevent click on body from firing instead of link
            evt.stopImmediatePropagation();
        });




        if ($('#MainContent .shopify-section').length > 1)
        {
            var waypointElement = $('#MainContent .shopify-section')[0];
        }
        else
        {
            var waypointElement = $('#shopify-section-collection-homepage div')[0];
        }

        var self = $('#shopify-section-header');

        $('#shopify-section-header').on('mouseenter', function()
        {
            self.addClass('inverse');
        });

        $('#shopify-section-header').on('mouseleave', function()
        {
            if ($(window).scrollTop() <= 900)
            {
                self.removeClass('inverse');
            }
        });


        var offset = 50;
        if (waypointElement)
        {
            self.waypoint = new Waypoint({
                element: waypointElement,
                handler: function(direction)
                {
                    if (direction == 'down')
                    {
                        self.addClass('inverse');
                    } else
                    {
                        self.removeClass('inverse');
                    }
                },
                offset: function()
                {
                    return -this.element.clientHeight + offset;
                }
            });
        }


        // Avoid excessively updating the position while scrolling.
        $(window).on('scroll', _.throttle(updatePosition, 100));

        var $lastPosition = 0;
        function updatePosition()
        {
            $position = $(window).scrollTop();
            if ($position <= 0)
            {
                $("#shopify-section-header").removeClass("inverse");
            }
            else
            {
                if ($position > 900)
                {
                    if ($position > $lastPosition)
                    {
                        $("#shopify-section-header").addClass("inverse");
                    }
                    // else if ($lastPosition - $position > 20) {
                    //   $("#shopify-section-header").removeClass("inverse");
                    // }
                }
            }

            $lastPosition = $position;
        }


    }

    // $('.site-header__shop-now > a').on('click touch', function (event) {
    //   event.preventDefault();
    //   var link = $(this).attr('href');
    //   window.location.replace(link);
    // });

    // $('.site-header__shop-now > a').hover( function (event) {
    //   event.preventDefault();
    //   var link = $(this).attr('href');
    //   window.location.replace(link);
    // });

    function cacheSelectors()
    {
        cache = _.assignIn({}, cache, {
            $nav: $(selectors.navigation),
            $topLevel: $(selectors.siteNavLinkMain),
            $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
            $subMenuLinks: $(selectors.siteNavChildLinks),
            $activeDropdown: $(selectors.siteNavActiveDropdown),
            $childLinksWithChildren: $(selectors.siteNavChildLinkWithChildren),
        });
    }

    function showDropdown($el)
    {
        $el.addClass(config.hoverClass);
        var dropdownActivationDelay = cache.isMobile ? 0 : 150;

        setTimeout(function()
        {
            if ($el.hasClass(config.hoverClass) || cache.isMobile)
            {
                $el.addClass(config.activeClass);

                // close open dropdowns
                if (cache.$activeDropdown.length)
                {
                    hideDropdown(cache.$activeDropdown);
                }

                cache.$activeDropdown = $el;

                // set expanded on open dropdown
                $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

                $(window).on('keyup.siteNav', function(evt)
                {
                    if (evt.keyCode === 27)
                    {
                        hideDropdown($el);
                    }
                });

                $(selectors.body).on('click.siteNav', function()
                {
                    hideDropdown($el);
                });
            } else
            {
                hideDropdown($el);
            }
        }, dropdownActivationDelay);
    }

    function hideDropdown($el)
    {
        // remove aria on open dropdown
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
        $el.removeClass(config.activeClass);
        $el.removeClass(config.hoverClass);

        // reset active dropdown
        cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

        $(selectors.body).off('click.siteNav');
        $(window).off('keyup.siteNav');
    }

    function unload()
    {
        $(window).off('.siteNav');
        cache.$parents.off('.siteNav');
        cache.$subMenuLinks.off('.siteNav');
        cache.$topLevel.off('.siteNav');
        $(selectors.siteNavChildLink).off('.siteNav');
        $(selectors.body).off('.siteNav');
    }




    return {
        init: init,
        unload: unload
    };
})();

window.theme = window.theme || {};

theme.MobileNav = (function()
{
    var classes = {
        mobileNavOpenIcon: 'mobile-nav--open',
        mobileNavCloseIcon: 'mobile-nav--close',
        navLink: 'mobile-nav__link',
        subNavLink: 'mobile-nav__sublist-link',
        return: 'mobile-nav__return-btn',
        subNavActive: 'is-active',
        subNavClosing: 'is-closing',
        navOpen: 'js-menu--is-open',
        subNavShowing: 'sub-nav--is-open',
        thirdNavShowing: 'third-nav--is-open',
        subNavToggleBtn: 'js-toggle-submenu'
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    var mediaQuerySmall = 'screen and (max-width: 767px)';

    function init()
    {
        cacheSelectors();

        cache.$mobileNavToggle.on('click', toggleMobileNav);
        cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

        // Close mobile nav when unmatching mobile breakpoint
        enquire.register(mediaQuerySmall, {
            unmatch: function()
            {
                closeMobileNav();
            }
        });
    }

    function toggleMobileNav()
    {
        if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon))
        {
            closeMobileNav();
        } else
        {
            openMobileNav();
        }
    }

    function cacheSelectors()
    {
        cache = {
            $pageContainer: $('#PageContent'),
            $mobileNavToggle: $('.js-mobile-nav-toggle'),
            $mobileNavContainer: $('.mobile-nav-wrapper'),
            $mobileNav: $('#MobileNav'),
            $sectionHeader: $('#shopify-section-header'),
            $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
        };
    }

    function openMobileNav()
    {
        var headerHeight = cache.$sectionHeader.outerHeight();

        cache.$mobileNavContainer
            .prepareTransition()
            .addClass(classes.navOpen);

        cache.$pageContainer.addClass(classes.navOpen);

        cache.$mobileNavContainer.css({
            transform: 'translate3d(0, 0, 0)',
            'padding-top': headerHeight + 'px'
        });

        cache.$pageContainer.css({
            overflow: 'hidden',
            height: '100vh',
        });

        slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNav
                .find('.' + classes.navLinkWrapper + ':first')
                .find('.' + classes.navLink),
            namespace: 'navFocus'
        });

        cache.$mobileNavToggle
            .addClass(classes.mobileNavCloseIcon)
            .removeClass(classes.mobileNavOpenIcon);

        $('html').addClass('js-mobile-open');
        // close on escape
        $(window).on('keyup.mobileNav', function(evt)
        {
            if (evt.which === 27)
            {
                closeMobileNav();
            }
        });
    }

    function closeMobileNav()
    {
        cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

        cache.$pageContainer.removeClass(classes.navOpen);

        cache.$mobileNavContainer.css({
            transform: 'translate3d(-100%, 0, 0)'
        });

        cache.$pageContainer.css({
            overflow: 'auto',
            height: 'auto'
        });

        cache.$mobileNavContainer.one(
            'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
            function()
            {
                slate.a11y.removeTrapFocus({
                    $container: cache.$mobileNav,
                    namespace: 'navFocus'
                });
            }
        );

        $('html').removeClass('js-mobile-open');

        cache.$mobileNavToggle
            .addClass(classes.mobileNavOpenIcon)
            .removeClass(classes.mobileNavCloseIcon);

        $(window).off('keyup.mobileNav');
    }

    function toggleSubNav(evt)
    {
        if (isTransitioning)
        {
            return;
        }

        var $toggleBtn = $(evt.currentTarget);
        var isReturn = $toggleBtn.hasClass(classes.return);
        isTransitioning = true;

        if (isReturn)
        {
            // Close all subnavs by removing active class on buttons
            $(
                '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
            ).removeClass(classes.subNavActive);

            if ($activeTrigger && $activeTrigger.length)
            {
                $activeTrigger.removeClass(classes.subNavActive);
            }
        } else
        {
            $toggleBtn.addClass(classes.subNavActive);
        }

        $activeTrigger = $toggleBtn;

        goToSubnav($toggleBtn.data('target'));
    }

    function goToSubnav(target)
    {

        /*eslint-disable shopify/jquery-dollar-sign-reference */

        var $targetMenu = target
            ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
            : cache.$mobileNav;

        menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

        if ($activeSubNav && $activeSubNav.length)
        {
            $activeSubNav
                .prepareTransition()
                .addClass(classes.subNavClosing);
        }

        $activeSubNav = $targetMenu;

        var $elementToFocus = target
            ? $targetMenu.find('.' + classes.subNavLink + ':first')
            : $activeTrigger;

        /*eslint-enable shopify/jquery-dollar-sign-reference */

        var translateMenuHeight = $targetMenu[0].scrollHeight;
        if (!target)
        {
            translateMenuHeight = $targetMenu.outerHeight();
        }

        var openNavClass = menuLevel > 2
            ? classes.thirdNavShowing
            : classes.subNavShowing;

        var newContainerHeight = translateMenuHeight + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;
        cache.$mobileNavContainer
            .css('height', newContainerHeight + 'px')
            .removeClass(classes.thirdNavShowing)
            .addClass('is-transitioning')
            .addClass(openNavClass);

        if (!target)
        {
            // Show top level nav
            cache.$mobileNavContainer
                .removeClass(classes.thirdNavShowing)
                .removeClass(classes.subNavShowing);
        }

        // Focusing an item in the subnav early forces element into view and breaks the animation.
        cache.$mobileNavContainer.one(
            'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
            function()
            {
                if ($elementToFocus.length > 1)
                {
                    slate.a11y.trapFocus({
                        $container: $targetMenu,
                        $elementToFocus: $elementToFocus,
                        namespace: 'subNavFocus'
                    });
                } else
                {
                    slate.a11y.trapFocus({
                        $container: cache.$sectionHeader,
                        $elementToFocus: cache.$mobileNav
                            .find('.' + classes.navLinkWrapper + ':first')
                            .find('.' + classes.navLink),
                        namespace: 'navFocus'
                    });
                }

                cache.$mobileNavContainer.off('.subnavToggle');
                cache.$mobileNavContainer.removeClass('is-transitioning');
                isTransitioning = false;
            }
        );

        // // Match height of subnav
        // cache.$pageContainer.css({
        //   overflow: 'hidden',
        //   height: newContainerHeight + 'px'
        // });

        // $activeSubNav.removeClass(classes.subNavClosing);
        $('.' + classes.subNavClosing).removeClass(classes.subNavClosing);

        // $('.mobile-nav-inner').scrollTo(0, {
        //   duration: 350
        // });
    }

    return {
        init: init,
        closeMobileNav: closeMobileNav
    };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function()
{
    var selectors = {
        search: '.search',
        searchSubmit: '.search__submit',
        searchInput: '.search__input',

        siteHeader: '.site-header',
        siteHeaderSearchToggle: '.js-search-toggle',

        searchHeader: '.search-header',
        searchHeaderInput: '.search-header__input',
        searchHeaderSubmit: '.search-header__submit',

        pageContent: '#PageContent'
    };

    var classes = {
        focus: 'search--focus',
        mobileNavIsOpen: 'js-menu--is-open',
        mobileSearchIsOpen: 'js-search--is-open'
    };

    var searchIsOpen = false;

    function init()
    {
        if (!$(selectors.siteHeader).length)
        {
            return;
        }

        $(selectors.searchSubmit).on('click', function(evt)
        {
            searchIsOpen = false;
            var $el = $(evt.target);
            var $input = $el.parents(selectors.search).find(selectors.searchInput);
            if ($input.val().length === 0)
            {
                evt.preventDefault();
                searchFocus($input);
            }
        });

        $(selectors.siteHeaderSearchToggle).on('click', activateSearch);

        $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus', activateSearch);
        $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('blur', deactivateSearch);
    }

    function activateSearch(evt)
    {
        if (evt.type != 'focus')
        {
            searchFocus($(selectors.searchInput));
        }

        searchIsOpen = true;

        $(selectors.searchHeader).addClass(classes.focus);
        $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
    }

    function deactivateSearch()
    {
        searchIsOpen = false;

        $(selectors.searchHeader).removeClass(classes.focus);
        $(selectors.pageContent).removeClass(classes.mobileSearchIsOpen);
    }

    function toggleSearch()
    {
        if (searchIsOpen)
        {

        } else
        {
            searchFocus($(selectors.searchInput));
            searchIsOpen = true;

            $(selectors.searchHeader).addClass(classes.focus);
            $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
        }
    }

    function searchFocus($el)
    {
        $el.focus();
        // set selection range hack for iOS
        $el[0].setSelectionRange(0, $el[0].value.length);
    }

    return {
        init: init
    };
})();

window.theme = window.theme || {};

theme.Slideshow = (function()
{
    this.$slideshow = null;
    var classes = {
        wrapper: 'slideshow-wrapper',
        slideshow: 'slideshow',
        currentSlide: 'slick-current',
        video: 'slideshow__video',
        videoBackground: 'slideshow__video--background',
        closeVideoBtn: 'slideshow__video-control--close',
        pauseButton: 'slideshow__pause',
        isPaused: 'is-paused'
    };
    // #TODO: Make these more global
    var config = {
        mediaQuerySmall: 'screen and (max-width: 600px)',
        mediaQueryMedium: 'screen and (min-width: 601px) and (max-width: 991px)',
        mediaQueryLargeUp: 'screen and (min-width: 992px)'
    };
    var defaults = {
        accessibility: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 7000,
        dots: false,
        draggable: true,
        fade: false,
        infinite: true,
        rows: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        slidesToShow: 1,
        swipeToSlide: true,
        touchThreshold: 20,
        centerMode: false,
        centerPadding: '40px',
    };

    function slideshow(el)
    {
        this.$slideshow = $(el);

        if (!this.$slideshow.length)
        {
            return;
        }

        this.$wrapper = this.$slideshow.closest('.' + classes.wrapper) || this.parent();
        this.$pause = this.$wrapper.find('.' + classes.pauseButton);
        this.sliderActive = false;
        var elementOptions = this.$slideshow.data();

        defaults.prevArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
        defaults.nextArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

        this.settings = {};
        this.settings.all = {
            fade: elementOptions.fade,
            draggable: elementOptions.draggable,
            arrows: elementOptions.arrows,
            autoplay: elementOptions.autoplay,
            autoplaySpeed: elementOptions.speed,
            dots: elementOptions.dots,
            infinite: elementOptions.infinite,
            slidesPerRow: elementOptions.perRow,
            slidesToScroll: elementOptions.slidesScroll,
            slidesToShow: elementOptions.slidesShow,
            rows: elementOptions.rows,
            centerMode: elementOptions.centerMode,
            centerPadding: elementOptions.centerPadding,
            focusOnSelect: elementOptions.focusOnSelect,
        };
        this.settings.desktop = {
            arrows: elementOptions.arrowsDesktop,
            autoplay: elementOptions.autoplayDesktop,
            autoplaySpeed: elementOptions.speedDesktop,
            dots: elementOptions.dotsDesktop,
            infinite: elementOptions.infiniteDesktop,
            slidesPerRow: elementOptions.perRowDesktop,
            slidesToScroll: elementOptions.slidesScrollDesktop,
            slidesToShow: elementOptions.slidesShowDesktop,
            rows: elementOptions.rowsDesktop,
            centerMode: elementOptions.centerModeDesktop,
            centerPadding: elementOptions.centerPaddingDesktop,
            focusOnSelect: elementOptions.focusOnSelectDesktop,
        };
        this.settings.tablet = {
            arrows: elementOptions.arrowsTablet,
            autoplay: elementOptions.autoplayTablet,
            autoplaySpeed: elementOptions.speedTablet,
            dots: elementOptions.dotsTablet,
            infinite: elementOptions.infiniteTablet,
            slidesPerRow: elementOptions.perRowTablet,
            slidesToScroll: elementOptions.slidesScrollTablet,
            slidesToShow: elementOptions.slidesShowTablet,
            rows: elementOptions.rowsTablet,
            centerMode: elementOptions.centerModeTablet,
            centerPadding: elementOptions.centerPaddingTablet,
            focusOnSelect: elementOptions.focusOnSelectTablet,
        };
        this.settings.mobile = {
            arrows: elementOptions.arrowsMobile,
            autoplay: elementOptions.autoplayMobile,
            autoplaySpeed: elementOptions.speedMobile,
            dots: elementOptions.dotsMobile,
            infinite: elementOptions.infiniteMobile,
            slidesPerRow: elementOptions.perRowMobile,
            slidesToScroll: elementOptions.slidesScrollMobile,
            slidesToShow: elementOptions.slidesShowMobile,
            rows: elementOptions.rowsMobile,
            centerMode: elementOptions.centerModeMobile,
            centerPadding: elementOptions.centerPaddingMobile,
            focusOnSelect: elementOptions.focusOnSelectMobile,
        };

        _.defaults(this.settings.desktop, this.settings.all);
        _.defaults(this.settings.desktop, defaults);

        _.defaults(this.settings.tablet, this.settings.all);
        _.defaults(this.settings.tablet, defaults);

        _.defaults(this.settings.mobile, this.settings.all);
        _.defaults(this.settings.mobile, defaults);


        this.$slideshow.on('beforeChange', beforeChange.bind(this));
        this.$slideshow.on('init', slideshowA11y.bind(this));
        // this.$slideshow.slick(this.settings);

        var self = this;

        enquire.register(config.mediaQuerySmall, {
            match: function()
            {
                if (!elementOptions.disableMobile)
                {
                    initSlider(self.$slideshow, self.settings.mobile);
                } else
                {
                    destroySlider(self.$slideshow);
                }
            }
        });

        enquire.register(config.mediaQueryMedium, {
            match: function()
            {
                if (!elementOptions.disableTablet)
                {
                    initSlider(self.$slideshow, self.settings.tablet);
                } else
                {
                    destroySlider(self.$slideshow);
                }
            }
        });

        enquire.register(config.mediaQueryLargeUp, {
            match: function()
            {
                if (!elementOptions.disableDesktop)
                {
                    initSlider(self.$slideshow, self.settings.desktop);
                } else
                {
                    destroySlider(self.$slideshow);
                }
            }
        });

        function initSlider(sliderObj, args)
        {
            if (self.sliderActive)
            {
                sliderObj.slick('unslick');
                self.sliderActive = false;
            }

            sliderObj.slick(args);
            self.sliderActive = true;

        }

        function destroySlider(sliderObj)
        {
            if (self.sliderActive)
            {
                sliderObj.slick('unslick');
                self.sliderActive = false;
            }
        }

        this.$pause.on('click', this.togglePause.bind(this));
    }

    function slideshowA11y(event, obj)
    {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;

        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');

        // When an element in the slider is focused
        // pause slideshow and set aria-live.
        $wrapper.on('focusin', function(evt)
        {
            if (!$wrapper.has(evt.target).length)
            {
                return;
            }

            $list.attr('aria-live', 'polite');

            if (autoplay)
            {
                $slider.slick('slickPause');
            }
        });

        // Resume autoplay
        $wrapper.on('focusout', function(evt)
        {
            if (!$wrapper.has(evt.target).length)
            {
                return;
            }

            $list.removeAttr('aria-live');

            if (autoplay)
            {
                // Manual check if the focused element was the video close button
                // to ensure autoplay does not resume when focus goes inside YouTube iframe
                if ($(evt.target).hasClass(classes.closeVideoBtn))
                {
                    return;
                }

                $slider.slick('slickPlay');
            }
        });

        // Add arrow key support when focused
        if (obj.$dots)
        {
            obj.$dots.on('keydown', function(evt)
            {
                if (evt.which === 37)
                {
                    $slider.slick('slickPrev');
                }

                if (evt.which === 39)
                {
                    $slider.slick('slickNext');
                }

                // Update focus on newly selected tab
                if ((evt.which === 37) || (evt.which === 39))
                {
                    obj.$dots.find('.slick-active button').focus();
                }
            });
        }
    }

    function beforeChange(event, slick, currentSlide, nextSlide)
    {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide);
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

        if (isVideoInSlide($currentSlide))
        {
            var $currentVideo = $currentSlide.find('.' + classes.video);
            var currentVideoId = $currentVideo.attr('id');
            theme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr('tabindex', '-1');
        }

        if (isVideoInSlide($nextSlide))
        {
            var $video = $nextSlide.find('.' + classes.video);
            var videoId = $video.attr('id');
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground)
            {
                theme.SlideshowVideo.playVideo(videoId);
            } else
            {
                $video.attr('tabindex', '0');
            }
        }
    }

    function isVideoInSlide($slide)
    {
        return $slide.find('.' + classes.video).length;
    }

    slideshow.prototype.togglePause = function()
    {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused))
        {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick('slickPlay');
        } else
        {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick('slickPause');
        }
    };

    function getSlideshowId($el)
    {
        return '#Slideshow-' + $el.data('id');
    }

    return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady()
{
    theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function()
{
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: {
            // eslint-disable-next-line camelcase
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange
        }
    };
    var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        slideshowWrapper: 'slideshow-wrapper',
        slide: 'slideshow__slide',
        slideBackgroundVideo: 'slideshow__slide--background-video',
        slideDots: 'slick-dots',
        videoChrome: 'slideshow__video--chrome',
        videoBackground: 'slideshow__video--background',
        playVideoBtn: 'slideshow__video-control--play',
        closeVideoBtn: 'slideshow__video-control--close',
        currentSlide: 'slick-current',
        slickClone: 'slick-cloned',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay'
    };

    /**
      * Public functions
     */
    function init($video)
    {
        if (!$video.length)
        {
            return;
        }

        videos[$video.attr('id')] = {
            id: $video.attr('id'),
            videoId: $video.data('id'),
            type: $video.data('type'),
            status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
            videoSelector: $video.attr('id'),
            $parentSlide: $video.closest('.' + classes.slide),
            $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
            controls: $video.data('type') === 'background' ? 0 : 1,
            slideshow: $video.data('slideshow')
        };

        if (!youtubeLoaded)
        {
            // This code loads the IFrame Player API code asynchronously.
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }

    function customPlayVideo(playerId)
    {
        // Do not autoplay just because the slideshow asked you to.
        // If the slideshow asks to play a video, make sure
        // we have done the playOnClick check first
        if (!playOnClickChecked && !playOnClick)
        {
            return;
        }

        if (playerId && typeof videoPlayers[playerId].playVideo === 'function')
        {
            privatePlayVideo(playerId);
        }
    }

    function pauseVideo(playerId)
    {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function')
        {
            videoPlayers[playerId].pauseVideo();
        }
    }

    function loadVideos()
    {
        for (var key in videos)
        {
            if (videos.hasOwnProperty(key))
            {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }

        initEvents();
        youtubeLoaded = true;
    }

    function loadVideo(key)
    {
        if (!youtubeLoaded)
        {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);

        initEvents();
    }

    /**
      * Private functions
     */

    function privatePlayVideo(id, clicked)
    {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;

        if (playOnClick)
        {
            // playOnClick means we are probably on mobile (no autoplay).
            // setAsPlaying will show the iframe, requiring another click
            // to play the video.
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable))
        {
            // Play if autoplay is available or clicked to play
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }

        // Check for autoplay if not already done
        if (!autoplayCheckComplete)
        {
            autoplayCheckFunction(player, $slide);
        }
    }

    function setAutoplaySupport(supported)
    {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);

        if (!supported)
        {
            playOnClick = true;
        }

        autoplayCheckComplete = true;
    }

    function autoplayCheckFunction(player, $slide)
    {
        // attempt to play video
        player.playVideo();

        autoplayTest(player)
            .then(function()
            {
                setAutoplaySupport(true);
            })
            .fail(function()
            {
                // No autoplay available (or took too long to start playing).
                // Show fallback image. Stop video for safety.
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function()
            {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }

    function autoplayTest(player)
    {
        var deferred = $.Deferred();
        var wait;
        var timeout;

        wait = setInterval(function()
        {
            if (player.getCurrentTime() <= 0)
            {
                return;
            }

            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);

        timeout = setTimeout(function()
        {
            clearInterval(wait);
            deferred.reject();
        }, 4000); // subjective. test up to 8 times over 4 seconds

        return deferred;
    }

    function playOnClickCheck()
    {
        // Bail early for a few instances:
        // - small screen
        // - device sniff mobile browser

        if (playOnClickChecked)
        {
            return;
        }

        if ($(window).width() < 750)
        {
            playOnClick = true;
        } else if (isMobile.any)
        {
            playOnClick = true;
        }

        if (playOnClick)
        {
            // No need to also do the autoplay check
            setAutoplaySupport(false);
        }

        playOnClickChecked = true;
    }

    // The API will call this function when each video player is ready
    function onPlayerReady(evt)
    {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);

        playOnClickCheck();

        // Prevent tabbing through YouTube player controls until visible
        $('#' + videoData.id).attr('tabindex', '-1');

        sizeBackgroundVideos();

        // Customize based on options from the video ID
        switch (videoData.type)
        {
            case 'background-chrome':
            case 'background':
                evt.target.mute();
                // Only play the video if it is in the active slide
                if (videoData.$parentSlide.hasClass(classes.currentSlide))
                {
                    privatePlayVideo(videoData.id);
                }
                break;
        }

        videoData.$parentSlide.addClass(classes.loaded);
    }

    function onPlayerChange(evt)
    {
        var videoData = getVideoOptions(evt);

        switch (evt.data)
        {
            case 0: // ended
                setAsFinished(videoData);
                break;
            case 1: // playing
                setAsPlaying(videoData);
                break;
            case 2: // paused
                setAsPaused(videoData);
                break;
        }
    }

    function setAsFinished(videoData)
    {
        switch (videoData.type)
        {
            case 'background':
                videoPlayers[videoData.id].seekTo(0);
                break;
            case 'background-chrome':
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
                break;
            case 'chrome':
                closeVideo(videoData.id);
                break;
        }
    }

    function setAsPlaying(videoData)
    {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;

        $slide.removeClass(classes.loading);

        // Do not change element visibility if it is a background video
        if (videoData.status === 'background')
        {
            return;
        }

        $('#' + videoData.id).attr('tabindex', '0');

        switch (videoData.type)
        {
            case 'chrome':
            case 'background-chrome':
                $slideshow
                    .removeClass(classes.paused)
                    .addClass(classes.playing);
                $slide
                    .removeClass(classes.paused)
                    .addClass(classes.playing);
                break;
        }

        // Update focus to the close button so we stay within the slide
        $slide.find('.' + classes.closeVideoBtn).focus();
    }

    function setAsPaused(videoData)
    {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;

        if (videoData.type === 'background-chrome')
        {
            closeVideo(videoData.id);
            return;
        }

        // YT's events fire after our click event. This status flag ensures
        // we don't interact with a closed or background video.
        if (videoData.status !== 'closed' && videoData.type !== 'background')
        {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }

        if (videoData.type === 'chrome' && videoData.status === 'closed')
        {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }

        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }

    function closeVideo(playerId)
    {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(' ');

        $('#' + videoData.id).attr('tabindex', '-1');

        videoData.status = 'closed';

        switch (videoData.type)
        {
            case 'background-chrome':
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case 'chrome':
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData); // in case the video is already paused
                break;
        }

        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }

    function getVideoOptions(evt)
    {
        return videos[evt.target.h.id];
    }

    function startVideoOnClick(playerId)
    {
        var videoData = videos[playerId];
        // add loading class to slide
        videoData.$parentSlide.addClass(classes.loading);

        videoData.status = 'open';

        switch (videoData.type)
        {
            case 'background-chrome':
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case 'chrome':
                privatePlayVideo(playerId, true);
                break;
        }

        // esc to close video player
        $(document).on('keydown.videoPlayer', function(evt)
        {
            if (evt.keyCode === 27)
            {
                closeVideo(playerId);
            }
        });
    }

    function sizeBackgroundVideos()
    {
        $('.' + classes.videoBackground).each(function(index, el)
        {
            sizeBackgroundVideo($(el));
        });
    }

    function sizeBackgroundVideo($player)
    {
        var $slide = $player.closest('.' + classes.slide);
        // Ignore cloned slides
        if ($slide.hasClass(classes.slickClone))
        {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();

        // when screen aspect ratio differs from video, video must center and underlay one dimension
        if (slideWidth / videoOptions.ratio < playerHeight)
        {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
            $player.width(playerWidth).height(playerHeight).css({
                left: (slideWidth - playerWidth) / 2,
                top: 0
            }); // player width is greater, offset left; reset top
        } else
        { // new video width < window width (gap to right)
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
            $player.width(slideWidth).height(playerHeight).css({
                left: 0,
                top: (playerHeight - playerHeight) / 2
            }); // player height is greater, offset top; reset left
        }

        $player
            .prepareTransition()
            .addClass(classes.loaded);
    }

    function unsetBackgroundVideo(playerId)
    {
        // Switch the background-chrome to a chrome-only player once played
        $('#' + playerId)
            .removeAttr('style')
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);

        videos[playerId].$parentSlideshowWrapper
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);

        videos[playerId].$parentSlide
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);

        videos[playerId].status = 'open';
    }

    function setBackgroundVideo(playerId)
    {
        // Switch back to background-chrome when closed
        var $player = $('#' + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);

        videos[playerId].$parentSlide
            .addClass(classes.slideBackgroundVideo);

        videos[playerId].status = 'background';
        sizeBackgroundVideo($player);
    }

    function initEvents()
    {
        $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt)
        {
            var playerId = $(evt.currentTarget).data('controls');
            startVideoOnClick(playerId);
        });

        $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt)
        {
            var playerId = $(evt.currentTarget).data('controls');
            closeVideo(playerId);
        });

        // Listen to resize to keep a background-size:cover-like layout
        if ($.debounce)
        {
            $(window).on('resize.videoPlayer', $.debounce(250, function()
            {
                if (youtubeLoaded)
                {
                    sizeBackgroundVideos();
                }
            }));
        }
    }

    function removeEvents()
    {
        $(document).off('.videoPlayer');
        $(window).off('.videoPlayer');
    }

    return {
        init: init,
        loadVideos: loadVideos,
        loadVideo: loadVideo,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
    };
})();

(function()
{
    var selectors = {
        backButton: '.return-link'
    };

    var $backButton = $(selectors.backButton);

    if (!document.referrer || !$backButton.length || !window.history.length)
    {
        return;
    }

    $backButton.one('click', function(evt)
    {
        evt.preventDefault();

        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);

        if (shopDomain === referrerDomain)
        {
            history.back();
        }

        return false;
    });

    function urlDomain(url)
    {
        var anchor = document.createElement('a');
        anchor.ref = url;

        return anchor.hostname;
    }
})();

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

window.theme = window.theme || {};

theme.RecentlyViewed = (function()
{

    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        onComplete: null
    };

    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;

    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function(recentlyViewed)
        {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function()
        {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            if (cookieValue !== null)
            {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function()
        {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function(productHandle)
        {
            var recentlyViewed = this.read();
            var position = jQuery.inArray(productHandle, recentlyViewed);
            if (position !== -1)
            {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    var finalize = function()
    {
        wrapper.show();
        // If we have a callback.
        if (config.onComplete)
        {
            try { config.onComplete() } catch (error) { }
        }
    };

    var moveAlong = function()
    {
        if (productHandleQueue.length && shown < config.howManyToShow)
        {
            jQuery.ajax({
                dataType: 'json',
                url: '/products/' + productHandleQueue[0] + '.js',
                cache: false,
                success: function(product)
                {
                    template.tmpl(product).appendTo(wrapper);
                    productHandleQueue.shift();
                    shown++;
                    moveAlong();
                },
                error: function()
                {
                    cookie.remove(productHandleQueue[0]);
                    productHandleQueue.shift();
                    moveAlong();
                }
            });
        } else
        {
            finalize();
        }

    };

    return {

        resizeImage: function(src, size)
        {
            if (size == null)
            {
                return src;
            }

            if (size == 'master')
            {
                return src.replace(/http(s)?:/, "");
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null)
            {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else
            {
                return null;
            }
        },

        showRecentlyViewed: function(params)
        {

            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = jQuery('#' + config.templateId);
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && template.length && wrapper.length)
            {
                // Getting each product with an Ajax call and rendering it on the page.
                moveAlong();
            }

        },

        getConfig: function()
        {
            return config;
        },

        clearList: function()
        {
            cookie.destroy();
        },

        recordRecentlyViewed: function(params)
        {

            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1)
            {

                // What is the product handle on this page.
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1)
                {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else
                {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);

            }
        }
    };
})();

(function()
{
    var selectors = {
        backButton: '.back-to-top',
    };

    var classes = {
        visible: 'back-to-top--visible',
        fade: 'back-to-top--fade',
    };

    var config = {
        showAfter: 300,
        dimAfter: 1200,
        scrollDuration: 700,
    };

    $backButton = $(selectors.backButton);

    if (!$backButton.length)
    {
        return;
    }

    $(window).scroll(function()
    {
        ($(this).scrollTop() > config.showAfter) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
        if ($(this).scrollTop() > config.dimAfter)
        {
            $backButton.addClass(classes.fade);
        }
    });

    $backButton.on('click', function(evt)
    {
        evt.preventDefault();
        $('body,html').animate({ scrollTop: 0 }, config.scrollDuration);
    });
})();

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function()
{

    if (window.Favico === undefined)
    {
        return;
    }

    var icon = new Favico({
        bgColor: '#0cbdc9',
        textColor: '#fff',
        fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
        fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
        type: 'circle', // circle, rectangle
        position: 'down', // up, down, left, upleft
        animation: 'none', // slide, fade, pop, popFade, none
        elementId: false, // Image element ID if there is need to attach badge to regular image
        element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
        dataUrl: false, // Method that will be called for each animation from with data URI parameter
    });

    if (window.shop.cart !== undefined && window.shop.cart.item_count > 0)
    {
        set(window.shop.cart.item_count);
    }

    function set(value)
    {
        icon.badge(value);
    }

    function reset()
    {
        icon.reset();
    }

    return {
        set: set,
        reset: reset
    };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function()
{

    function init()
    {
        Currency.format = shop.currencyFormat;

        var shopCurrency = shop.currency;

        /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
        Currency.moneyFormats[shopCurrency].money_with_currency_format = shop.moneyWithCurrencyFormat;
        Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat;

        /* Default currency */
        var defaultCurrency = shop.defaultCurrency;

        /* Cookie currency */
        var cookieCurrency = Currency.cookie.read();

        /* Fix for customer account pages */
        $('span.money span.money').each(function()
        {
            $(this).parents('span.money').removeClass('money');
        });

        /* Saving the current price */
        $('span.money').each(function()
        {
            $(this).attr('data-currency-' + shop.currency, $(this).html());
        });

        // If there's no cookie.
        if (cookieCurrency == null)
        {
            if (shopCurrency !== defaultCurrency)
            {
                Currency.convertAll(shopCurrency, defaultCurrency);
            }
            else
            {
                Currency.currentCurrency = defaultCurrency;
            }
        }
        // If the cookie value does not correspond to any value in the currency dropdown.
        else if ($('[name=currencies]').length && $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0)
        {
            Currency.currentCurrency = shopCurrency;
            Currency.cookie.write(shopCurrency);
        }
        else if (cookieCurrency === shopCurrency)
        {
            Currency.currentCurrency = shopCurrency;
        }
        else
        {
            Currency.convertAll(shopCurrency, cookieCurrency);
        }

        $('[name=currencies]').val(Currency.currentCurrency).change(function()
        {
            var newCurrency = $(this).val();
            Currency.convertAll(Currency.currentCurrency, newCurrency);
            $('.selected-currency').text(Currency.currentCurrency);
        });

        var original_selectCallback = window.selectCallback;
        var selectCallback = function(variant, selector)
        {
            original_selectCallback(variant, selector);
            Currency.convertAll(shopCurrency, $('[name=currencies]').val());
            $('.selected-currency').text(Currency.currentCurrency);
        };

        $(document).on('cart.requestComplete', function(event, cart)
        {
            Currency.convertAll(shopCurrency, $('[name=currencies]').val());
            $('.selected-currency').text(Currency.currentCurrency);
        });

        $('.selected-currency').text(Currency.currentCurrency);
        $('.currency-picker__wrapper').removeClass('loading');
    }

    return {
        init: init,
    };
})();

theme.videoPlayers = theme.videoPlayers || {};

(function()
{
    var selectors = {
        lightboxTriggers: '.video-lightbox__trigger, .rte a[href*="youtube.com"], .rte a[href*="youtu.be"]',
        placeholderImages: '.video-lightbox__trigger img.placeholder, .video-lightbox__trigger .placeholder-svg',
    };

    $(selectors.lightboxTriggers).yu2fvl({
        minPaddingX: 60, // the space you want on *top and bottom when centering the video (value is divided by 2)
        minPaddingY: 60, // the space you want on *left and right when centering the video (value is divided by 2)
        ratio: 16 / 9, // choose the ration you want for your video
        cssClass: "video-lightbox", // set a namespace / global css class
        overlayCssClass: "__overlay", // give a suffix css class for the overlay
        iframeCssClass: "__iframe", // give a suffix css class for the iframe
        closeCssClass: "__close", // give a suffix css class for the close button
        // #TODO: Handle the SVG close button a little more nicely
        closeText: "<svg viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(381 231)\"><path d=\"M-370.7-174.7l-2.3-2.3 46-46 2.3 2.3-46 46\"/><path d=\"M-327-174.7l-46-46 2.3-2.3 46 46-2.3 2.3\"/></g></svg>", // give some text for the close button
        vid: false, // set directly a youtube video id (though using an anchor is cool for SEO !)
        open: false // Open the lightbox immediately from JavaScript. Requires vid to be set to work properly.
    });

    var frameScript = document.createElement('script');
    frameScript.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(frameScript, firstScriptTag);

    $(selectors.lightboxTriggers).on('click', function(evt)
    {
        var videoID = $(this).data('video-id') || $(this).parent().data('video-id') || false;
        if (!videoID)
        {
            return;
        }

        var $iframe = $('.video-lightbox__iframe[src*=' + $(this).data('video-id') + ']')
        if (!$iframe.length)
        {
            return;
        }

        if (theme.videoPlayers[videoID] == undefined)
        {
            $iframe.attr('id', 'lightbox-video-' + videoID);
            theme.videoPlayers[videoID] = new YT.Player('lightbox-video-' + videoID, {
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
        }
    });

    function onPlayerStateChange(evt)
    {
        var player = evt.target;
        if (player.getPlayerState !== undefined && player.getPlayerState() == 0)
        {
            player.seekTo(0);
            var videoID = evt.target.getVideoData().video_id;
            $('#lightbox-video-' + videoID + ' ~ .video-lightbox__close').trigger('click');
        }
    }

    var $placeholders = $(selectors.placeholderImages);

    if (!$placeholders.length)
    {
        return;
    }

    $placeholders.each(function()
    {
        var $el = $(this);
        var $trigger = $el.parents('.video-lightbox__trigger');
        var videoID = $el.data('video-id') || $trigger.data('video-id') || theme.utils.getYoutubeId($trigger.href);

        if (!videoID)
        {
            return;
        }

        var image = new Image();
        image.src = 'https://i.ytimg.com/vi/' + videoID + '/maxresdefault.jpg';
        image.onload = function()
        {
            if (image.naturalWidth !== undefined && image.naturalWidth < 200 && image.src.indexOf('hqdefault') !== -1)
            {
                image.src = image.src.replace('sddefault', 'hqdefault').replace('maxresdefault', 'sddefault');
                return;
            }

            if ($el.hasClass('placeholder-svg'))
            {
                $el.parent('.video-lightbox__placeholder').replaceWith(image);
            } else
            {
                $el.attr('src', image.src);
            }
        }
    });

})();

window.theme = window.theme || {};

theme.Video = (function()
{

    var selectors = {
        videoContainer: '.video',
    };

    var sources = {
        vimeo: 'https://player.vimeo.com/api/player.js',
        youtube: 'https://www.youtube.com/iframe_api'
    };

    var methods = {
        vimeo: function(elem)
        {
            var player = new Vimeo.Player(elem);
            player.play();
        },
        youtube: function(elem)
        {
            if ((typeof YT !== "undefined") && YT && YT.Player)
            {
                var player = new YT.Player(elem, {
                    events: {
                        'onReady': onPlayerReady
                    }
                });
            }

            function onPlayerReady(event)
            {
                event.target.playVideo();
            }
        }
    };

    var cache = {
        videoTypes: [],
        videoTypesLoaded: []
    };

    function init()
    {
        if (!$(selectors.videoContainer).length)
        {
            return;
        }

        _loadPlayerAPIs();
        _bindEventListeners();
    };

    function _loadPlayerAPIs()
    {
        var videoTypes = [],
            videoType,
            $videoContainer;

        for (i = 0; i < $(selectors.videoContainer).length; i++)
        {
            $videoContainer = $(selectors.videoContainer)[i];
            videoType = $($videoContainer).attr('data-video-type');

            if (cache.videoTypes.indexOf(videoType) === -1)
            {
                cache.videoTypes.push(videoType);
            }
        }

        for (i = 0; i < cache.videoTypes.length; i++)
        {
            videoType = cache.videoTypes[i];
            _includePlayer(videoType);
        }
    }

    function _includePlayer(type)
    {
        var source = sources[type];

        if (source == undefined)
        {
            console.error('Video type ' + type + ' is not supported');
            return;
        }

        if ($('script[src="' + source + '"]').length)
        {
            cache.videoTypesLoaded.push(type);
            return;
        }

        loadJS(source, function()
        {
            cache.videoTypesLoaded.push(type);

            if (_checkAdditionalSources())
            {
                _autoPlay();
            }
        });
    }

    function _checkAdditionalSources()
    {
        for (i = 0; i < cache.videoTypes.length; i++)
        {
            var type = cache.videoTypes[i];
            if (cache.videoTypesLoaded.indexOf(type) === -1)
            {
                return false;
            }
        }
        return true;
    }

    function _autoPlay()
    {
        for (var i = $(selectors.videoContainer).length - 1; i >= 0; i--)
        {
            var $videoContainer = $(selectors.videoContainer)[i],
                videoIsVisible = $($videoContainer).is(':visible'),
                videoType = $($videoContainer).attr('data-video-type'),
                videoAutoPlay = $($videoContainer).attr('data-video-autoplay');
            videoVisible = $($videoContainer).attr('data-video-visible');

            if (videoIsVisible && videoAutoPlay == 'true' && videoVisible == 'true')
            {
                methods[videoType]($($videoContainer).find('iframe')[0]);
            }
        }
    }

    function _bindEventListeners()
    {
        $(selectors.videoContainer).on('click', _revealVideo);
    }

    function _revealVideo()
    {
        var videoType = $(this).attr('data-video-type'),
            videoId = $(this).attr('data-video-id');

        methods[videoType]($(this).find('iframe')[0]);

        $(this).attr('data-video-visible', 'true');
    }

    return {
        init: init
    };

})();

theme.Video.init();
/*============================================================================
  PRODUCT FEATURED POINTS
==============================================================================*/
window.theme = window.theme || {};
window.theme.productFeaturedPointsData = window.theme.productFeaturedPointsData || {};

theme.ProductFeaturedPoints = (function()
{

    var selectors = {
        data: '#product-featured-points-data',
        point: '.featured-points__point',
        navArrow: '.featured-points__nav-arrow'
    };

    var defaults = {
        activeClass: 'points-initialized',
        pointsActiveClass: 'points-active'
    };

    function ProductFeaturedPoints(el)
    {
        this.$el = $(el);
        if (!this.$el.length)
        {
            return;
        }

        this.type = $(this.$el).data('product-type') || 'not type defined';

        this.productFeaturedPointsData = JSON.parse($(selectors.data).html());

        if (!this.productFeaturedPointsData[this.type])
        {
            console.error('No type exists for: ' + this.type);
            return;
        }

        //Bind TinyBind
        tinybind.bind($(this.$el), { data: this.productFeaturedPointsData[this.type] });
        this.productFeaturedPointsData[this.type].active_point = this.productFeaturedPointsData[this.type].points[0];

        this.$points = this.$el.find(selectors.point);
        this.$navArrows = this.$el.find(selectors.navArrow);

        var self = this;

        function _changeActivePoint(pointIndex)
        {
            $(self.$el).removeClass('points-active');
            self.productFeaturedPointsData[self.type].active_point = self.productFeaturedPointsData[self.type].points[pointIndex];

            setTimeout(function()
            {
                $(self.$el).addClass('points-active');
            }, 1);
        }

        // Bind click events
        $(this.$points).on('click', function()
        {
            var pointIndex = $(this).data('point');
            _changeActivePoint(pointIndex);
        });

        $(this.$navArrows).on('click', function()
        {
            var active = self.productFeaturedPointsData[self.type].active_point.id;
            var pointsCount = self.productFeaturedPointsData[self.type].points.length;
            var newActive;
            if ($(this).data('nav') == 'next')
            {
                if (active + 1 == pointsCount)
                {
                    newActive = 0;
                } else
                {
                    newActive = active + 1;
                }
            } else if ($(this).data('nav') == 'prev')
            {
                if (active == 0)
                {
                    newActive = pointsCount - 1;
                } else
                {
                    newActive = active - 1;
                }
            }
            _changeActivePoint(newActive);
        });

        $(this.$el).addClass(defaults.activeClass);
        $(this.$el).addClass(defaults.pointsActiveClass);
    }

    return ProductFeaturedPoints;
})();
window.theme = window.theme || {};

/*============================================================================
  TAB GROUPS
==============================================================================*/

theme.TabsGroup = (function()
{

    var selectors = {
        container: '.tabs-group',
        tab: '.tabs-group__tab'
    };

    var defaultOptions = {
        activeTab: 1,
        tabsActiveClass: 'tabs-group--active',
        navContainerClass: 'tabs-group__nav',
        tabNavItemClass: 'tabs-group__nav-item',
        accordionNavItemClass: 'tabs-group__accordion-nav-item',
        breakpoint: 990,
        transitionDuration: 0.5
    };

    function TabsGroup(el, options)
    {
        this.$tabsGroup = $(el);

        if (!this.$tabsGroup.length)
        {
            return;
        }

        this.options = _.defaults(options, defaultOptions);

        this.config = {
            mediaQueryAccordion: 'screen and (min-width: 0px)',
            // mediaQueryTabs: 'screen and (min-width:  ' + (this.options.breakpoint + 1) + 'px)'
        };

        this.$tabs = this.$tabsGroup.find(selectors.tab);
        this.$navContainer = $('<div></div>').addClass(this.options.navContainerClass);

        // Set initial tab states
        for (var j = this.$tabs.length - 1; j >= 0; j--)
        {
            var $tab = $(this.$tabs[j]);
            var tabId = $tab.data('tab');
            var tabTitle = $tab.data('tabTitle');

            var $navItem = $('<div></div>')
                .attr('data-target', tabId)
                .html(tabTitle);

            if (tabId == this.options.activeTab)
            {
                this.activeTab = tabId;
                $tab.attr('data-active', 'true');
                $navItem.attr('data-active', 'true');
            } else
            {
                $tab.attr('data-active', 'false');
                $navItem.attr('data-active', 'false');
            }

            var $tabNavItem = $navItem;
            var $accordionNavItem = $navItem.clone();

            $tabNavItem.addClass(this.options.tabNavItemClass);
            this.$navContainer.prepend($tabNavItem);

            $accordionNavItem.addClass(this.options.accordionNavItemClass).insertBefore($tab);

        }

        this.$tabsGroup.prepend(this.$navContainer);
        this.$navItems = this.$tabsGroup.find('[data-target]');

        var self = this;

        enquire.register(this.config.mediaQueryAccordion, {
            match: function()
            {
                self.$tabsGroup.attr('data-tabs-type', 'accordion');
            }
        });

        enquire.register(this.config.mediaQueryTabs, {
            match: function()
            {
                self.$tabsGroup.attr('data-tabs-type', 'tabs');
            }
        });

        // Bind nav click events
        $(this.$navItems).on('click', function()
        {
            var target = $(this).data('target');

            if (self.activeTab == target)
            {
                self._closeAll();
            } else
            {
                self._goTo(target);
                self.activeTab = target;
            }

        });

        $(this.$tabsGroup).addClass(this.options.tabsActiveClass);
    }

    TabsGroup.prototype = $.extend({}, TabsGroup.prototype, {

        _closeAll: function()
        {
            var self = this;

            if (self.$tabsGroup.attr('data-tabs-type') != 'accordion')
            {
                return;
            }

            var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

            var animate = false;
            if ($(window).width() < this.options.breakpoint)
            {
                animate = true;
            }

            var height = {
                active: {}
            };

            if (animate)
            {
                height.active.current = $activeTab.height();
                $activeTab.css('height', height.active.current);
            }

            $(self.$tabs).attr('data-active', 'false');
            $(self.$navItems).attr('data-active', 'false');

            if (animate)
            {
                height.active.new = 0;

                $activeTab.height(height.active.current);

                $activeTab.height(height.active.new);

                setTimeout(function()
                {
                    $activeTab.css('height', '');
                }, self.options.transitionDuration * 1000);
            }

            self.activeTab = false;

        },
        _goTo: function(target)
        {
            var self = this;

            var $tab = $('[data-tab="' + target + '"]', self.$tabsGroup);
            var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

            var animate = false;
            if ($(window).width() < this.options.breakpoint)
            {
                animate = true;
            }

            var height = {
                target: {},
                active: {}
            };

            if (animate)
            {
                height.target.current = 0;
                $tab.css('height', height.target.current);

                height.active.current = $activeTab.height();
                $activeTab.css('height', height.active.current);
            }

            $(self.$tabs).attr('data-active', 'false');
            $(self.$navItems).attr('data-active', 'false');

            var $target = self.$tabsGroup.find('[data-tab=' + target + ']');
            $($target).attr('data-active', 'true');

            var $targetNav = self.$tabsGroup.find('[data-target=' + target + ']');
            $($targetNav).attr('data-active', 'true');

            if (animate)
            {
                height.target.new = $tab.css('height', 'auto').get(0).scrollHeight;
                height.active.new = 0;

                $tab.height(height.target.current);
                $activeTab.height(height.active.current);

                $tab.height(height.target.new);
                $activeTab.height(height.active.new);

                setTimeout(function()
                {
                    $tab.css('height', '');
                    $activeTab.css('height', '');

                    $(window).scrollTo($target, {
                        duration: self.options.transitionDuration * 1000 * 0.66,
                        interrupt: !isMobile.apple.device,
                        offset: -100
                    });

                }, self.options.transitionDuration * 1000);
            }

            self.activeTab = target;
        }

    })

    return TabsGroup;
})();

/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function()
{
    var selectors = {
        edit: '.js-edit-toggle'
    };
    var config = {
        showClass: 'cart__update--show',
        showEditClass: 'cart__edit--active',
        cartNoCookies: 'cart--no-cookies'
    };

    function Cart(container)
    {
        this.$container = $(container);
        this.$edit = $(selectors.edit, this.$container);

        if (!this.cookiesEnabled())
        {
            this.$container.addClass(config.cartNoCookies);
        }

        this.$edit.on('click', this._onEditClick.bind(this));
    }

    Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function()
        {
            this.$edit.off('click', this._onEditClick);
        },

        _onEditClick: function(evt)
        {
            var $evtTarget = $(evt.target);
            var $updateLine = $('.' + $evtTarget.data('target'));

            $evtTarget.toggleClass(config.showEditClass);
            $updateLine.toggleClass(config.showClass);
        },

        cookiesEnabled: function()
        {
            var cookieEnabled = navigator.cookieEnabled;

            if (!cookieEnabled)
            {
                document.cookie = 'testcookie';
                cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
            }
            return cookieEnabled;
        }
    });

    return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function()
{
    var constants = {
        SORT_BY: 'sort_by'
    };
    var selectors = {
        filterSelection: '.collection-filters__dropdown--filter',
        sortSelection: '.collection-filters__dropdown--sort',
        defaultSort: '.collection-filters__default-sort',
        filterPlaceholderDesktop: '.collection-filters-placeholder--desktop',
        filterPlaceholderMobile: '.collection-filters-placeholder--mobile',
        filterContentDesktop: '.collection-filters-content--desktop',
        filterContentMobile: '.collection-filters-content--mobile',
        filterSection: '[data-section-type="collection-filters"]',
        filterSectionWrapper: '#shopify-section-collection-filters',
    };

    function Filters(container)
    {
        var $container = this.$container = $(container);

        this.initFilters();

        this.$filterSelects = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);
        this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

        this.defaultSort = this._getDefaultSortValue();
        this._resizeSelect(this.$selects);
        this.$selects.removeClass('hidden');

        this.$filterSelects.on('change', this._onFilterChange.bind(this));
        this.$sortSelect.on('change', this._onSortChange.bind(this));
    }

    Filters.prototype = _.assignIn({}, Filters.prototype, {

        /**
         * Initialises filters
         */
        initFilters: function()
        {
            var self = this;
            var $filterSectionWrapper = $(selectors.filterSectionWrapper);

            var $filterContentMobile = $(selectors.filterContentMobile, $filterSectionWrapper).html();
            var $filterContentDesktop = $(selectors.filterContentDesktop, $filterSectionWrapper).html();

            $(selectors.filterPlaceholderMobile, this.$container).replaceWith($filterContentMobile);
            $(selectors.filterPlaceholderDesktop, this.$container).replaceWith($filterContentDesktop);
        },

        _onSortChange: function(evt)
        {
            var sort = this._sortValue();
            if (sort.length)
            {
                window.location.search = sort;
            } else
            {
                // clean up our url if the sort value is blank for default
                window.location.href = window.location.href.replace(window.location.search, '');
            }
            this._resizeSelect($(evt.target));
        },

        _onFilterChange: function(evt)
        {
            // window.location.href = $(evt.target).val() + window.location.search;
            var newLocation = $(evt.target).val();
            if (window.location.search != '')
            {
                var currentQueryParams = theme.utils.getQueryParams();
                for (var k in currentQueryParams)
                {
                    if (currentQueryParams.hasOwnProperty(k))
                    {
                        newLocation = theme.utils.updateQueryStringParameter(k, currentQueryParams[k], newLocation);
                    }
                }
                var newQueryParams = theme.utils.getQueryParams(newLocation);
                for (var k in newQueryParams)
                {
                    if (newQueryParams.hasOwnProperty(k))
                    {
                        newLocation = theme.utils.updateQueryStringParameter(k, newQueryParams[k], newLocation);
                    }
                }
                window.location.href = newLocation;
            }
            this._resizeSelect($(evt.target));
        },

        _getSortValue: function()
        {
            return this.$sortSelect.val() || this.defaultSort;
        },

        _getDefaultSortValue: function()
        {
            return $(selectors.defaultSort, this.$container).val();
        },

        _sortValue: function()
        {
            var sort = this._getSortValue();
            var query = '';

            if (sort !== this.defaultSort)
            {
                query = constants.SORT_BY + '=' + sort;
            }

            return query;
        },

        _resizeSelect: function($selection)
        {
            $selection.each(function()
            {
                var $this = $(this);
                var arrowWidth = 10;
                // create test element
                var text = $this.find('option:selected').text();
                var $test = $('<span>').html(text);

                // add to body, get width, and get out
                $test.appendTo('body');
                var width = $test.width();
                $test.remove();

                // set select width
                $this.width(width + 5 + arrowWidth);
            });
        },

        onUnload: function()
        {
            this.$filterSelects.off('change', this._onFilterChange);
            this.$sortSelect.off('change', this._onSortChange);
        }
    });

    return Filters;
})();

theme.HeaderSection = (function()
{

    function Header()
    {
        theme.Header.init();
        theme.MobileNav.init();
        theme.Search.init();
    }

    Header.prototype = _.assignIn({}, Header.prototype, {
        onUnload: function()
        {
            theme.Header.unload();
        }
    });



    return Header;
})();

theme.Maps = (function()
{
    var config = {
        zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
    var key = theme.mapKey ? theme.mapKey : '';

    function Map(container)
    {
        this.$container = $(container);

        if (apiStatus === 'loaded')
        {
            this.createMap();
        } else
        {
            mapsToLoad.push(this);

            if (apiStatus !== 'loading')
            {
                apiStatus = 'loading';
                if (typeof window.google === 'undefined')
                {
                    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
                        .then(function()
                        {
                            apiStatus = 'loaded';
                            initAllMaps();
                        });
                }
            }
        }
    }

    function initAllMaps()
    {
        // API has loaded, load all Map instances in queue
        $.each(mapsToLoad, function(index, instance)
        {
            instance.createMap();
        });
    }

    function geolocate($map)
    {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data('address-setting');

        geocoder.geocode({ address: address }, function(results, status)
        {
            if (status !== google.maps.GeocoderStatus.OK)
            {
                deferred.reject(status);
            }

            deferred.resolve(results);
        });

        return deferred;
    }

    Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function()
        {
            var $map = this.$container.find('.map-section__container');

            return geolocate($map)
                .then(function(results)
                {
                    var mapOptions = {
                        zoom: config.zoom,
                        center: results[0].geometry.location,
                        disableDefaultUI: true
                    };

                    var map = this.map = new google.maps.Map($map[0], mapOptions);
                    var center = this.center = map.getCenter();

                    //eslint-disable-next-line no-unused-vars
                    var marker = new google.maps.Marker({
                        map: map,
                        position: map.getCenter()
                    });

                    google.maps.event.addDomListener(window, 'resize', $.debounce(250, function()
                    {
                        google.maps.event.trigger(map, 'resize');
                        map.setCenter(center);
                    }));
                }.bind(this))
                .fail(function()
                {
                    var errorMessage;

                    switch (status)
                    {
                        case 'ZERO_RESULTS':
                            errorMessage = theme.strings.addressNoResults;
                            break;
                        case 'OVER_QUERY_LIMIT':
                            errorMessage = theme.strings.addressQueryLimit;
                            break;
                        default:
                            errorMessage = theme.strings.addressError;
                            break;
                    }

                    $map
                        .parent()
                        .addClass('page-width map-section--load-error')
                        .html('<div class="errors text-center">' + errorMessage + '</div>');
                });
        },

        onUnload: function()
        {
            google.maps.event.clearListeners(this.map, 'resize');
        }
    });

    return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure()
{
    $('.map-section').addClass('map-section--load-error');
    $('.map-section__container').remove();
    $('.map-section__link').remove();
    $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function()
{
    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productSku: '[data-product-sku]',
        productPrice: '[data-product-price]',
        productImageWrap: '[data-product-images-wrap]',
        productImageContainer: '[data-product-images]',
        productImages: '[data-product-image]',
        productActiveImage: '[data-product-active-image]',
        productThumbContainer: '[data-product-thumbnails]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]',
        productQtyWrapper: '.product-form__item--quantity',
        partialBackorderMessage: '.js-partial-backorder',
        partialBackorderInput: '.partial-backorder-input',
        productColoursData: 'script#product-colour-data',
        jsProductColours: '.js-product-colors',
        jsProductSizes: '.js-product-sizes'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container)
    {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {
            // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
            mediaQueryMediumUp: 'screen and (min-width: 768px)',
            mediaQuerySmall: 'screen and (max-width: 767px)',
            enableHistoryState: this.$container.data('enable-history-state') || false,
            sectionId: sectionId,
            sliderActive: false,
            bpSmall: false,
            zoomEnabled: false
        };
        this.namespace = '.product';

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html())
        {
            return;
        }

        //theme.ProductOptions(container);
        this.options = new ProductOptions(container);
        this.options.initialize();

        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
        this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
        this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass('js-zoom-enabled');

        // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

        // this.initBreakpoints();
        this.initImageSlider();
        this.initGallery();
        this.initVariants();
        this.initTabGroups();

        var readMoreLink = '<a aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more</a>';

        $('.product-single__description').readmore({
            speed: 75,
            collapsedHeight: 100,
            heightMargin: 100,
            moreLink: readMoreLink,
            lessLink: false,
            beforeToggle: function(trigger, element, expanded)
            {
                $(element).toggleClass('readmore-expanded');
            }
        });

        // Overdose
        //this._buildColourOptions();

        // Prosper Digital
        //this._buildProductOptions();

        this.checkIfPartialBackorder();

        var self = this;
        $('.product-form__item-inner').on('click', '.js-qty-select button', function()
        {
            //have to wait for correct amonunt to update input first
            setTimeout(function()
            {
                self.checkIfPartialBackorder();
            }, 500);
        });

        // Overdose page reload on product selector change
        /*
        $(document).on('change', '.js-product-color, .js-product-size, .js-product-version', function()
        {
            var link = this.options[this.selectedIndex].dataset.link;
            if (link != '#')
            {
                window.location.href = link;
            }
        });
        */
    }

    Product.prototype = $.extend({}, Product.prototype,
    {
        /**
         * Creates linked sliders for product main and thumb images
         */
        initImageSlider: function()
        {
            var thumbOptions = {
                slidesToShow: 5,
                swipeToSlide: true,
                infinite: true,
                asNavFor: selectors.productImageContainer,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            };

            var mainOptions = {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                arrows: true,
                infinite: true,
                focusOnSelect: true,
                fade: true,
                adaptiveHeight: true,
                asNavFor: selectors.productThumbContainer,
                prevArrow: selectors.productImageContainer + ' ~ .product-images__prev',
                nextArrow: selectors.productImageContainer + ' ~ .product-images__next',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            // arrows: true,
                            fade: false,
                            dots: true,
                        }
                    }
                ]
            };

            $activeProductImage = $(selectors.productActiveImage).first();
            if ($activeProductImage.length > 0)
            {
                var firstSlide = $activeProductImage.index() || 0;
                mainOptions.initialSlide = firstSlide;
            }

            if ($(selectors.productImageWrap, this.$container).is('[data-vertical]'))
            {
                thumbOptions = $.extend({}, thumbOptions, {
                    vertical: true,
                    verticalSwiping: true,
                });
            }

            if (this.productSingleObject.images.length > 1)
            {
                $(selectors.productThumbContainer).slick(thumbOptions);
            }

            $(selectors.productImageContainer).slick(mainOptions);

            this.settings.sliderActive = true;
        },

        checkIfPartialBackorder: function()
        {
            var quantity = $('.product-form input[type="number"]').val();
            var availableStockCount = parseInt($(selectors.partialBackorderMessage).data().available);

            if (availableStockCount <= 0)
            {
                $(selectors.partialBackorderMessage).addClass('hidden');
                $(selectors.partialBackorderInput).remove();
            }
            else
            {
                if (quantity > availableStockCount)
                {
                    var countOnBackorder = quantity - availableStockCount;
                    $(selectors.partialBackorderMessage).removeClass('hidden');
                    $('.product-form').append('<input type="hidden" class="partial-backorder-input" name="properties[Available]" value="with ' + countOnBackorder + ' item(s) placed on backorder">');
                }
                else
                {
                    $(selectors.partialBackorderMessage).addClass('hidden');
                    $(selectors.partialBackorderInput).remove();
                }
            }
        },

        initTabGroups: function()
        {
            var $tabsGroups = $('.tabs-group');
            if (!$tabsGroups.length)
            {
                return;
            }

            window.tabsGroups = {};

            for (var i = $tabsGroups.length - 1; i >= 0; i--)
            {
                tabsGroups[i] = new theme.TabsGroup($tabsGroups[i]);
            }
        },

        // TODO : Remove old OD code
        _buildProductOptions: function()
        {
            let self = this;

            self.productOptions =
            {
                loading: true
            };

            self.productRelated =
            {
                loading: true,
                similarProducts: []
            };

            let $productColorContainer = $(selectors.jsProductColours);

            tinybind.bind($productColorContainer, {
                data: self.productOptions
            });

            let productFamilyTag = $productColorContainer.attr('data-family') || $productColorContainer.attr('data-color');
            let familyName = productFamilyTag.substring(productFamilyTag.indexOf('-') + 1)

            if (familyName.match(/[A-Za-z]{3}/))
            {
                familyName = familyName.substring(0, 5);
            }
            else
            {
                familyName = familyName.substring(0, 4);
            }

            let currentColor = $productColorContainer.attr('data-current-color');
            let currentSize = $productColorContainer.attr('data-current-size') || $productColorContainer.attr('data-size');
            let currentHandle = $productColorContainer.attr('data-current-handle');
            let currentFunction = $productColorContainer.attr('data-function');

            self.currentHandle = $productColorContainer.attr('data-current-handle');
            currentSize = currentSize.replace('size-', '');
            currentFunction = currentFunction.replace('function-', '').capitalize();

            let allProducts, allColors, allSizes, allFunctions;

            let apiEndPoints = {
                local: 'https://localhost:44308/api/products/family/' + familyName,
                remote: 'https://prosperdigital.com.au/Meir/api/products/family/' + familyName,
                cdn: '//cdn.shopify.com/s/files/1/0047/5686/5094/t/72/assets/product-data.json?latest'
            };

            $.getJSON(apiEndPoints.local, function(data)
            {
                allProducts = data[familyName].products;
                allColors = _.map(data[familyName].colors, function(color ) { return color.capitalize() });
                allSizes = data[familyName].sizes;
                allFunctions = _.map(data[familyName].functions, function(func) { return func.capitalize() });

                normalizeProductProperties();
                initializeProducts();
                initializeColors();
                initializeSizes();
                initializeFunctions();
                initializeSimilarProducts();
                applyColorFilter();
                hookEvents();
                getProductDataCallback(data)
            });

            function getProductDataCallback()
            {
                self.productOptions.loading = false;
                $('.product-options-placholder').addClass('visually-hidden');
            }

            function normalizeProductProperties()
            {
                $.each(allProducts, function(index, product)
                {
                    if (product.color != null) product.color = product.color.capitalize();
                    if (product.function != null) product.function = product.function.capitalize();
                    product.url = '/products/' + product.handle;

                    let shortTitleParts = [];

                    if (product.color != null) shortTitleParts.push(product.color);
                    if (product.size != null) shortTitleParts.push(product.size);
                    if (product.function != null) shortTitleParts.push(product.function);

                    product.shortTitle = shortTitleParts.join(' - ');

                });
            }

            function initializeProducts()
            {
                self.productOptions.products = allProducts;
            }

            function initializeColors()
            {
                self.productOptions.colors = allColors;
                self.productOptions.selectedColor = currentColor;
            }

            function initializeSizes()
            {
                self.productOptions.sizes = allSizes;
                self.productOptions.selectedSize = currentSize;
            }

            function initializeFunctions()
            {
                self.productOptions.functions = allFunctions;
                self.productOptions.selectedFunction = currentFunction;
            }

            function applyColorFilter()
            {
                let color = $('.js-product-color').val();
                let filteredProducts = _.filter(allProducts, function(product) { return product.color == color; });
                let availableSizes = _.map(filteredProducts, function(product) { return product.size; });

                self.productOptions.sizes = _.intersection(allSizes, availableSizes);

                applySizeFilter();
            }

            function applySizeFilter()
            {
                let size = $('.js-product-size').val();
                let color = $('.js-product-color').val();

                let filteredProducts = _.filter(allProducts, function(product) { return product.size == size && product.color == color; });
                let availableFunctions = _.map(filteredProducts, function(product) { return product.function; });

                self.productOptions.functions = _.intersection(allFunctions, availableFunctions);
            }

            function initializeSimilarProducts()
            {
                var showSimilarProducts = false;

                if ($('.js-similar-products').length)
                {
                    showSimilarProducts = true;
                    var $productSimilarProducts = $('.js-similar-products');

                    tinybind.bind($productSimilarProducts, {
                        data: self.productRelated
                    });
                }

                $.each(self.productOptions.products, function (index, product)
                {
                    if (showSimilarProducts == false) return;
                    if (isSimilarProductValid(product) == false) return;

                    product.featured_image = product.featured_image.replace('_{width}x', '');

                    self.productRelated.similarProducts.push(product);
                });

                if (self.productRelated.similarProducts.length > 0)
                {
                    $('.product-single__backorder-link').removeClass('hidden');
                }
            }

            function isSimilarProductValid(product)
            {
                if (self.productRelated.similarProducts.length >= 1) return false;
                if (product.backorder) return false;
                if (product.handle == self.currentHandle) return false;

                return true;
            }

            function hookEvents()
            {
                $(document).on('change', '.js-product-color', function(e)
                {
                    applyColorFilter();
                    self.productOptions.selectedProduct = getSelectedProduct();
                });

                $(document).on('change', '.js-product-size', function(e)
                {
                    applySizeFilter();
                    self.productOptions.selectedProduct = getSelectedProduct();
                });

                $(document).on('change', '.js-product-function', function(e)
                {
                    self.productOptions.selectedProduct = getSelectedProduct();
                });

                $(".js-product.single").click(function(e) {
                    e.preventDefault();
                });

                $(document).on('change', '.js-product', function(e)
                {
                    let selectedProduct= getSelectedProduct()

                    if (selectedProduct.errMessage != '' )
                    {
                        console.log(selectedProduct);
                    }
                    else
                    {
                        redirectToSelectedProductUrl(selectedProduct.url)
                    }
                });
            }

            function redirectToSelectedProductUrl(productUrl)
            {
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                });

                $('.svg-loader-wrap').removeClass('visually-hidden');
                $('.product-page-container').fadeOut(500);

                window.location = productUrl;
            }

            function getSelectedProduct()
            {
                let color = $('.js-product-color').find(':selected').val();
                let size = $('.js-product-size').val();
                let func = $('.js-product-function').val();

                let result = _.filter(allProducts, function(product)
                {
                    return product.color == color && product.size == size && product.function == func;
                });

                if (result == null || result.length == 0 )
                {
                    return {
                    errMessage: 'null product'
                    };
                }
                else if (result[0].handle == currentHandle)
                {
                    return {
                        errMessage: 'selected option has same handle'
                    };
                }

                return {
                    sku : result[0].sku,
                    url : '/products/' + result[0].handle,
                    errMessage: ''
                };
            }
        },


        _buildColourOptions: function()
        {
            var self = this;
            var colorSwatchEnabled = false;
            //get global colour information
            if (colorSwatchEnabled)
            {
                var $colorData = $(selectors.productColoursData);

                if ($colorData.length)
                {
                    self.colorData = JSON.parse($colorData.html());

                } else
                {
                    return;
                }
            }
            self.productOptions = {
                loading: true
            };
            self.productRelated = {
                loading: true,
                similarProducts: []
            };

            var $productColorContainer = $(selectors.jsProductColours);

            tinybind.bind($productColorContainer, {
                data: self.productOptions
            });

            var showSimilarProducts = false;

            if ($('.js-similar-products').length)
            {
                showSimilarProducts = true;
                var $productSimilarProducts = $('.js-similar-products');

                tinybind.bind($productSimilarProducts, {
                    data: self.productRelated
                });
            }

            var productGroupTag = $productColorContainer.attr('data-color');
            var productSizeTag = $productColorContainer.attr('data-size');
            var productVersionTag = $productColorContainer.attr('data-version');

            self.currentHandle = $productColorContainer.attr('data-current-handle');
            var currentColor = $productColorContainer.attr('data-current-color');
            var currentSize = $productColorContainer.attr('data-current-size');
            //var currentVersion = $productColorContainer.attr('data-current-version');


            var callsToMake = 0;
            if (productGroupTag)
            {
                callsToMake++;
            }
            if (productSizeTag)
            {
                callsToMake++;
            }
            if (productVersionTag)
            {
                callsToMake++;
            }

            function checkRemainingCalls()
            {
                callsToMake -= 1
                if (callsToMake == 0)
                {
                    self.productOptions.loading = false;
                }
            };

            if (productGroupTag)
            {
                $.get('/collections/all/' + productGroupTag + '?view=json', function(data)
                {
                    var productColorOptions = JSON.parse(data);
                    var filteredColors = productColorOptions;

                    if (currentSize != null && currentSize != '')
                    {
                        filteredColors = _.filter(productColorOptions, { 'size': currentSize });
                    }

                    self.productOptions.colors = filteredColors;

                    _.each(self.productOptions.colors, function(product, index)
                    {
                        var color = product.color;

                        if (showSimilarProducts && self.productRelated.similarProducts.length < 2)
                        {
                            if (!product.backorder && product.handle != self.currentHandle)
                            {
                                self.productRelated.similarProducts.push(product);
                            }
                        }

                        product.featured_image = product.featured_image.replace('_{width}x', '');

                        if (colorSwatchEnabled)
                        {
                            var colorData = _.find(self.colorData, { 'title': color });
                        }

                        if (product.handle == self.currentHandle)
                        {

                            self.productOptions.colors[index].url = '#';
                            self.productOptions.selectedColor = color;
                        }
                    });

                    if (self.productRelated.similarProducts.length > 0)
                    {
                        $('.product-single__backorder-link').removeClass('hidden');
                    }

                    checkRemainingCalls();
                });
            }

            if (productSizeTag)
            {
                $.get('/collections/all/' + productSizeTag + '?view=json', function(data)
                {
                    var productSizeOptions = JSON.parse(data);
                    var filteredSizes = _.filter(productSizeOptions, { 'color': currentColor });
                    self.productOptions.sizes = filteredSizes;
                    //filter size options based on the current colour
                    _.each(self.productOptions.sizes, function(product, index)
                    {
                        var size = product.size;

                        if (colorSwatchEnabled)
                        {
                            var colorData = _.find(self.colorData, { 'title': size });
                        }

                        if (product.handle == self.currentHandle)
                        {
                            self.productOptions.sizes[index].url = '#';
                            self.productOptions.selectedSize = size;
                        }
                    });
                    checkRemainingCalls();
                });
            }

            if (productVersionTag)
            {
                $.get('/collections/all/' + productVersionTag + '?view=json', function(data)
                {
                    var productVersionOptions = JSON.parse(data);
                    var filteredVersions = productVersionOptions;
                    // if(currentColor.length > 0){
                    //   filteredVersions = _.filter(productVersionOptions, {'color': currentColor});
                    // }

                    //dont show empty values
                    filteredVersions = _.filter(productVersionOptions, function(x)
                    {
                        if (x.version != '')
                        {
                            return x;
                        }
                    });

                    filteredVersions = _.sortBy(filteredVersions, ['version', 'color']);
                    self.productOptions.versions = filteredVersions;

                    _.each(self.productOptions.versions, function(product, index)
                    {
                        var version = product.version;
                        var color = product.color;
                        var size = product.size;
                        // append color name to end - because duplicates show
                        self.productOptions.versions[index].version = version + (color != '' ? ' - ' + color : '') + (size != '' ? ' - ' + size : '');

                        if (product.handle == self.currentHandle)
                        {
                            self.productOptions.versions[index].url = '#';
                            self.productOptions.selectedVersion = product.version;
                        }

                    });
                    checkRemainingCalls();
                });
            }
        },

        /**
         * Sets up product image lightbox with Photoswipe.js
         */
        initGallery: function()
        {
            var self = this;

            if (self.settings.zoomEnabled)
            {
                var pswpElement = document.querySelectorAll('.pswp')[0];
                var items = $('[data-pswp-items]').data('pswp-items');

                $(selectors.productImageWrap, this.$container).on('click', '.zoom-js', function(e)
                {
                    e.preventDefault();
                    var thumbnail = $(this).find('img')[0];
                    options = {
                        index: $(this).data('index'),
                        barsSize: { top: 0, bottom: 0 },
                        captionEl: false,
                        fullscreenEl: false,
                        shareEl: false,
                        bgOpacity: 0.96,
                        tapToClose: true,
                        tapToToggleControls: false,
                        history: false,
                        getThumbBoundsFn: function(index)
                        {
                            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                                rect = thumbnail.getBoundingClientRect(),
                                thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
                            return { x: rect.left + thumbInfo.left, y: rect.top + pageYScroll, w: thumbInfo.width };
                        }
                    };

                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

                    var realViewportWidth,
                        useLargeImages = false,
                        firstResize = true,
                        imageSrcWillChange;

                    // gettingData event fires each time PhotoSwipe retrieves image source & size
                    gallery.listen('gettingData', function(index, item)
                    {

                        realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

                        // Set image source & size based on real viewport width
                        if (useLargeImages)
                        {
                            item.src = item.originalImage.src;
                            item.w = item.originalImage.w;
                            item.h = item.originalImage.h;
                            item.msrc = item.originalImage.msrc;
                        } else
                        {
                            if (realViewportWidth > 1024)
                            {
                                item.w = 1600;
                            } else if (realViewportWidth > 768)
                            {
                                item.w = 1024;
                            } else if (realViewportWidth > 640)
                            {
                                item.w = 768;
                            } else if (realViewportWidth > 480)
                            {
                                item.w = 640;
                            } else
                            {
                                item.w = 480;
                            }
                            item.w = Math.min(item.w, item[index].originalWidth);
                            item.h = Math.round(item.w / item[index].ratio);

                            var itemSrcTemplate = decodeURI(item[index].src);
                            item.src = itemSrcTemplate.replace('{width}', item.w);
                            // item.msrc = itemSrcTemplate.replace('{width}', 180);

                            var $imageElem = $(selectors.productImageContainer + ' [data-slick-index="' + index + '"]:not(.slick-cloned) img');
                            item.msrc = $imageElem.prop('currentSrc') || $imageElem.attr('src') || item[index].msrc;
                        }

                        // It doesn't really matter what will you do here,
                        // as long as item.src, item.w and item.h have valid values.
                        //
                        // Just avoid http requests in this listener, as it fires quite often

                    });

                    gallery.listen('close', function()
                    {
                        if (self.settings.sliderActive)
                        {
                            $(selectors.productImageContainer).slick('slickGoTo', this.getCurrentIndex());
                        }
                    });

                    gallery.init();

                });
            }
        },

        /**
         * Handles change events from the variant inputs
         */
        initVariants: function()
        {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject
            };

            this.variants = new slate.Variants(options);

            this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
            this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
            this.$container.on('variantSKUChange' + this.namespace, this.updateSKU.bind(this));
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt)
        {
            var variant = evt.variant;

            if (variant)
            {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else
            {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available)
            {
                var quantityAvailable = Math.max(variant.inventory_quantity, 0);
                quantityAvailable = quantityAvailable > 0 ? quantityAvailable : 999;
                $(selectors.productQtyWrapper + ' input', this.$container).prop('max', quantityAvailable);
                $(selectors.productQtyWrapper + ' input', this.$container).prop('min', 1);
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else
            {
                $(selectors.productQtyWrapper + ' input', this.$container).prop('max', 0);
                $(selectors.productQtyWrapper + ' input', this.$container).prop('min', 0);
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt)
        {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
            var comparePrefixString = $comparePrice.data('prefix-string') || '';
            var compareSuffixString = $comparePrice.data('suffix-string') || '';

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price)
            {
                $comparePrice.html(comparePrefixString + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + compareSuffixString);
                $compareEls.removeClass('hide');
            } else
            {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }

            var $afterpayInstallments = $('#afterpay_instalments', this.$container);
            if ($afterpayInstallments.length)
            {
                $afterpayInstallments.html(slate.Currency.formatMoney(variantPrice / 4, theme.moneyFormat));
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt)
        {
            var self = this;
            var variant = evt.variant;

            if (self.settings.sliderActive)
            {
                var imageIndex = $('[data-image-id="' + variant.featured_image.id + '"]:not(.slick-cloned)').data('slick-index');
                $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
            } else
            {
                var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
                $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
            }
        },

        /**
         * Updates the DOM with specified Variant SKU
         */
        updateSKU: function(evt)
        {
            var variant = evt.variant;

            // Update the sku
            $(selectors.productSku, this.$container).html(variant.sku);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function()
        {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

class ProductOptions
{
    constructor(container)
    {
        this.selectors =
        {
            productJson: '[data-product-json]',
            jsProductColours: '.js-product-colors'
        }

        this.viewModel = null;
        this.$container = $(container);
        this.siblingTag = "family--";
        this.oldSiblingTag = "group-";
        this.candidateOptions = ['color', 'rose_size', 'shower_function'];
        this.product = this.parseProductJson();
        this.loading = true;
        this.productRelated = {
            similarProducts: []
        };
    }

    initialize()
    {
        this.getSiblingsAsync().then(data =>
        {
            this.onGotSiblings(data);
            this.initializeSimilarProducts();

            this.loading = false;
        });
    }

    parseProductJson()
    {
        let json = $(this.selectors.productJson, this.$container).html();

        return JSON.parse(json);
    }

    async getSiblingsAsync()
    {
        this.loading = true;

        let tag = this.getFamilyTag();

        let promise = new Promise((resolve, reject) =>
        {
            let url = `/collections/all/${tag}?view=json`;

            $.get(url, (data) => resolve(JSON.parse(data)));
        });

        return promise;
    }

    getFamilyTag()
    {
        let tag = this.getTagByPrefix(this.siblingTag, this.product.tags);

        if (tag)
        {
            return tag;
        }

        return this.getTagByPrefix(this.oldSiblingTag, this.product.tags);
    }

    getTagByPrefix(prefix, tags)
    {
        return _.find(tags, tag => tag.startsWith(prefix));
    }

    onGotSiblings(siblings)
    {
        let viewModel = new ProductOptionsViewModel(siblings, this.product.handle);
        this.viewModel = viewModel;

        this.bindViewModel(viewModel);
        this.hookEvents(viewModel);
    }

    bindViewModel(viewModel)
    {
        let $productColorContainer = $(this.selectors.jsProductColours);

        tinybind.bind($productColorContainer, { viewModel: viewModel });
    }

    initializeSimilarProducts()
    {
        var showSimilarProducts = false;

        if ($('.js-similar-products').length)
        {
            showSimilarProducts = true;
            var $productSimilarProducts = $('.js-similar-products');

            tinybind.bind($productSimilarProducts, {
                data: this.productRelated
            });
        }

        $.each(this.viewModel.products, (index, product) =>
        {
            if (showSimilarProducts == false) return;
            if (this.isSimilarProductValid(product) == false) return;

            product.featured_image = product.featured_image.replace('_{width}x', '');

            this.productRelated.similarProducts.push(product);
        });

        if (this.productRelated.similarProducts.length > 0)
        {
            $('.product-single__backorder-link').removeClass('hidden');
        }
    }

    isSimilarProductValid(product)
    {
        if (this.productRelated.similarProducts.length >= 1) return false;
        if (product.backorder) return false;
        if (product.handle == self.currentHandle) return false;

        return true;
    }

    hookEvents(viewModel)
    {
        //$(document).on('mousedown', '.js-product-color', () => viewModel.onColorMouseDown());
        //$(document).on('mousedown', '.js-product-rose-size', () => viewModel.onRoseSizeMouseDown());
        //$(document).on('mousedown', '.js-product-shower-function', () => viewModel.onShowerFunctionMouseDown());
        $(document).on('change', '.js-product', () => {
            viewModel.onOptionSelected();
        });
        $(document).on('click', '.js-goto-product', () => viewModel.redirectToSelectedProduct());
        $(document).on('click', '.js-product-color-item', () => {
            viewModel.onOptionSelected();
        });
    }
}

class ProductOptionsViewModel
{
    constructor(products, handle)
    {
        this.products = products;
        this.product = _.find(this.products, product => product.handle == handle);

        if (this.product == null) return;

        if (this.product.color == "Gold Black") this.product.color = "Gold & Black";
        if (this.product.color == "Black Gold") this.product.color = "Black & Gold";

        this.selectedColor = this.product.color;
        this.selectedRoseSize = this.product.rose_size;
        this.selectedShowerFunction = this.product.shower_function;
        this.selectedProduct = this.product;

        this.allColors = this.getColors(this.products);
        this.allRoseSizes = this.getRoseSizes(this.products);
        this.allShowerFunctions = this.getShowerFunctions(this.products);

        this.availableColors = this.allColors;
        this.availableRoseSizes = this.allRoseSizes;
        this.availableShowerFunctions = this.allShowerFunctions;

        this.hasOptions = this.allColors.length > 0 || this.allRoseSizes.length > 0 || this.allShowerFunctions.length > 0;

        this.numOptions = 0;
        if (this.allColors.length > 0) this.numOptions++;
        if (this.allRoseSizes.length > 0) this.numOptions++;
        if (this.availableShowerFunctions.length > 0) this.numOptions++;

        setTimeout(() => {
            this.onOptionSelected();
            this.initColorSelectors();
        }, 100);
    }

    getColors(products)
    {
        let colors = _.chain(products).map(product => product.color).reject(color => color == "" || color == null).uniq().sortBy(color => this.getColorSortIndex(color)).value();

        for (var n = 0; n < colors.length; n++)
        {
            if (colors[n] == "Gold Black") colors[n] = "Gold & Black";
            if (colors[n] == "Black Gold") colors[n] = "Black & Gold";
        }

        return colors;
    }

    getColorSortIndex(color)
    {
        let index = [
            "Matte Black",
            "Tiger Bronze",
            "Tiger Bronze Gold",
            "Champagne",
            "Polished Chrome",
            "Chrome",
            "Black Gold",
            "Black & Gold",
            "Black & Bronze",
            "Bronze & Black",
            "Gold Black",
            "Gold & Black",
            "Brushed Nickel"
        ].indexOf(color);

        if (index == -1) return 99;

        return index;
    }

    getRoseSizes(products)
    {
        return _.chain(products).map(product => product.rose_size).reject(roseSize => roseSize == "" || roseSize == null).uniq().sortBy(p => p).value();
    }

    getShowerFunctions(products)
    {
        return _.chain(products).map(product => product.shower_function).reject(showerFunction => showerFunction == "" || showerFunction == null).uniq().sortBy(p => p).value();
    }

    onColorMouseDown()
    {
        let products = this.getAvailableProductsForOption("color");

        this.availableColors = this.getColors(products);
    }

    onRoseSizeMouseDown()
    {
        let products = this.getAvailableProductsForOption("rose_size");

        this.availableRoseSizes = this.getRoseSizes(products);
    }

    onShowerFunctionMouseDown()
    {
        let products = this.getAvailableProductsForOption("shower_function");

        this.availableShowerFunctions = this.getShowerFunctions(products);
    }

    getAvailableProductsForOption(option)
    {
        let selectedOptions = this.getSelectedOptions();

        let products = _.filter(this.products, product =>
            (product.color == selectedOptions.color || option == "color")
            && (product.rose_size == selectedOptions.roseSize || option == "rose_size")
            && (product.shower_function == selectedOptions.showerFunction || option == "shower_function")
        );

        return products;
    }

    getSelectedOptions()
    {
        return {
            color : $('.js-product-color').val() || "",
            roseSize : $('.js-product-rose-size').val() || "",
            showerFunction : $('.js-product-shower-function').val() || ""
        }
    }

    onOptionSelected()
    {
        this.selectedProduct = this.getAvailableProductsForOption()[0];

        if (this.numOptions == 1 && this.selectedProduct != this.product && this.selectedProduct != null)
        {
            this.redirectToSelectedProduct();
        }
        else
        {
            this.isInvalidSelection = this.getIsInvalidSelection();
        }
    }

    getIsInvalidSelection()
    {
        if (this.selectedProduct == null || this.selectedProduct == undefined)
        {
            this.message = "Unavailable";
            return true;
        }

        if (this.selectedProduct == this.product)
        {
            this.message = "View Product";
            return true;
        }

        this.message = "View Product";
        return false;
    }

    getMessage()
    {
        return "Message";
    }

    redirectToSelectedProduct()
    {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });

        $('.svg-loader-wrap').removeClass('visually-hidden');
        $('.product-page-container').fadeOut(500);

        if (this.selectedProduct == null) return false;

        let location = this.selectedProduct.url;

        window.location.href = location;

        return false;
    }

    
    /**
     * Binds click event on color icons to trigger same redirect logic
     */
    bindColorIconRedirect()
    {
        const self = this;
        const $productColorItem = $('.js-product-color-item');
        const $productColorSelect = $('.js-product-color');
        const $selectedProductColor = $('.js-selected-product-color');

        $productColorItem.off('click.redirectColor').on('click.redirectColor', function() {
            const $this = $(this);
            const colorValue = $this.data('value');

            // Update dropdown and UI
            $productColorSelect.val(colorValue);
            $selectedProductColor.html(colorValue);
            $productColorItem.removeClass('selected');
            $this.addClass('selected');

            // Trigger change so viewModel updates `selectedProduct`
            $productColorSelect.trigger('change');

            // Wait for viewModel to update, then call redirect
            setTimeout(function() {
                self.redirectToSelectedProduct();
            }, 200);

            return false;
        });
    }

    /**
     * Handles change events from the color selectors
     */
    initColorSelectors()
    {
        const $productColorSelectorsWrapper = $('.js-product-color-selectors-wrapper')
        const $productColorItem = $('.js-product-color-item');
        const $productColorSelect = $('.js-product-color');
        const initialValue = $productColorSelect.val();
        const $initialProductColorItem = $productColorSelectorsWrapper.find('[data-value="' + initialValue + '"]');
        const $selectedProductColor = $('.js-selected-product-color');
        const allAvailableColorOptions = $.map($productColorSelect.find('option'), el => $(el).data('link'));

        $.each($productColorItem, (idx, el) => {
            const $this = $(el);
            const value = $this.data('value');
            const indexInAvailableOptions = allAvailableColorOptions.findIndex((item) => (item === value));

            if (indexInAvailableOptions >= 0) {
                $this.css('display', 'flex');
            }
        });

        $initialProductColorItem.addClass('selected');
        $selectedProductColor.html(initialValue);
        $productColorItem.on('click', function() {
            const $this = $(this);
            const colorValue = $this.data('value');

            $productColorSelect.val(colorValue);
            $selectedProductColor.html(colorValue);
            $productColorItem.removeClass('selected');
            $this.addClass('selected');
        });
        this.bindColorIconRedirect();
    }
}

theme.Quotes = (function()
{
    var config = {
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        slideCount: 0
    };
    var defaults = {
        arrows: true,
        dots: false,
        autoplay: false,
        touchThreshold: 20,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    function Quotes(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var wrapper = this.wrapper = '.quotes';
        var slider = this.slider = '#Quotes-' + sectionId;
        var $slider = $(slider, wrapper);

        defaults.prevArrow = '#Quotes-' + sectionId + ' ~ .slideshow__prev';
        defaults.nextArrow = '#Quotes-' + sectionId + ' ~ .slideshow__next';

        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
        });

        config.slideCount = $slider.data('count');

        // Override slidesToShow/Scroll if there are not enough blocks
        if (config.slideCount < defaults.slidesToShow)
        {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }

        $slider.on('init', this.a11y.bind(this));

        enquire.register(config.mediaQuerySmall, {
            match: function()
            {
                initSlider($slider, mobileOptions);
            }
        });

        enquire.register(config.mediaQueryMediumUp, {
            match: function()
            {
                initSlider($slider, defaults);
            }
        });

        function initSlider(sliderObj, args)
        {
            if (sliderActive)
            {
                sliderObj.slick('unslick');
                sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;
        }
    }

    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function()
        {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);

            $(this.slider, this.wrapper).slick('unslick');
        },

        onBlockSelect: function(evt)
        {
            // Ignore the cloned version
            var $slide = $('.quotes__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
            var slideIndex = $slide.data('slick-index');

            // Go to selected slide, pause autoplay
            $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
        },

        a11y: function(event, obj)
        {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);

            // Remove default Slick aria-live attr until slider is focused
            $list.removeAttr('aria-live');

            // When an element in the slider is focused set aria-live
            $wrapper.on('focusin', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.attr('aria-live', 'polite');
                }
            });

            // Remove aria-live
            $wrapper.on('focusout', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return Quotes;
})();

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function()
{
    function SlideshowSection(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#Slideshow-' + sectionId;

        $('.slideshow__video', slideshow).each(function()
        {
            var $el = $(this);
            theme.SlideshowVideo.init($el);
            theme.SlideshowVideo.loadVideo($el.attr('id'));
        });

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function()
    {
        delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt)
    {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function()
    {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});

window.theme = window.theme || {};

theme.BrandValueSliders = (function()
{
    var config = {
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        slideCount: 0,
        anchorPosition: 'above', // above, below
        anchorElement: '.site-header-lower',
        anchorViewport: 'small' // large, small
    };

    var cache = {
        anchorMarginBottom: 0,
        anchorMarginTop: 0,
        anchorOffset: 0
    }

    var defaults = {
        arrows: false,
        dots: false,
        autoplay: false,
        touchThreshold: 20,
        slidesToShow: 3,
        swipeToSlide: true,
        slidesToScroll: 1
    };

    function brandValueSliders(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var wrapper = this.wrapper = '.brand-values-wrap';
        var slider = this.slider = '#brand-values-' + sectionId;
        var $slider = $(slider, wrapper);
        var $contentContainer = $('#PageContent');
        var $anchorElement = $(config.anchorElement);

        var mobileOptions = $.extend({}, defaults, {
            // arrows: true,
            // slidesToShow: 1,
            // slidesToScroll: 1,
            // adaptiveHeight: true,
            // autoplay: $slider.data('autoplay-mobile'),
            // autoplaySpeed: $slider.data('speed')

            // overriding options to show no slides on mobiles:
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 0,
            adaptiveHeight: true,
            autoplay: $slider.data('autoplay-mobile'),
            autoplaySpeed: 0
        });

        var sliderActive = false;
        var desktopOptions = $.extend({}, defaults, {
            autoplay: $slider.data('autoplay'),
            autoplaySpeed: $slider.data('speed'),
            slidesToShow: $slider.data('slides-show-desktop')
        });

        config.slideCount = $slider.data('count');

        // Override slidesToShow/Scroll if there are not enough blocks
        if (config.slideCount < defaults.slidesToShow)
        {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }

        $slider.on('init', this.a11y.bind(this));

        if ($anchorElement.length)
        {
            cache.anchorMarginTop = parseInt($anchorElement.css("marginTop").replace('px', ''));
            cache.anchorMarginBottom = parseInt($anchorElement.css("marginBottom").replace('px', ''));
        }

        enquire.register(config.mediaQuerySmall, {
            deferSetup: true,
            match: function()
            {
                initSlider($slider, mobileOptions);

                if ($anchorElement.length)
                {
                    $anchorElement.css({
                        'margin-top': cache.anchorMarginTop + 'px',
                        'margin-bottom': cache.anchorMarginBottom + 'px'
                    });

                    if (config.anchorViewport == 'small' || config.anchorViewport == 'all')
                    {
                        $container.css('position', 'fixed');
                        switch (config.anchorPosition)
                        {
                            case 'above':
                                cache.anchorOffset = $anchorElement.offset().top;
                                var anchorAdjustment = {
                                    'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                                };
                                var sliderAdjustment = {
                                    'top': cache.anchorOffset + 'px'
                                };
                                break;
                            default:
                                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                                var anchorAdjustment = {
                                    'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                                };
                                var sliderAdjustment = {
                                    'top': cache.anchorOffset + 'px'
                                };
                                break;
                        }
                    } else
                    {
                        var anchorAdjustment = {
                            'margin-bottom': cache.anchorMarginBottom + 'px'
                        };
                        var sliderAdjustment = {
                            'position': 'static',
                            'top': '0px'
                        };
                    }

                    $anchorElement.css(anchorAdjustment);
                    $container.not('.brand-values--cloned').css(sliderAdjustment);
                }
            }
        });

        enquire.register(config.mediaQueryMediumUp, {
            deferSetup: true,
            match: function()
            {
                initSlider($slider, desktopOptions);
                if ($anchorElement.length)
                {
                    $anchorElement.css({
                        'margin-top': cache.anchorMarginTop + 'px',
                        'margin-bottom': cache.anchorMarginBottom + 'px'
                    });

                    if (config.anchorViewport == 'large' || config.anchorViewport == 'all')
                    {
                        $container.css('position', 'fixed');
                        switch (config.anchorPosition)
                        {
                            case 'above':
                                cache.anchorOffset = $anchorElement.offset().top;
                                var anchorAdjustment = {
                                    'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                                };
                                var sliderAdjustment = {
                                    'position': 'fixed',
                                    'top': cache.anchorOffset + 'px'
                                };
                                break;
                            default:
                                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                                var anchorAdjustment = {
                                    'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                                };
                                var sliderAdjustment = {
                                    'position': 'fixed',
                                    'top': cache.anchorOffset + 'px'
                                };
                                break;
                        }
                    } else
                    {
                        var anchorAdjustment = {
                            'margin-bottom': cache.anchorMarginBottom + 'px'
                        };
                        var sliderAdjustment = {
                            'position': 'static',
                            'top': '0px'
                        };
                    }

                    $anchorElement.css(anchorAdjustment);
                    $container.not('.brand-values--cloned').css(sliderAdjustment);
                }
            }
        });

        function initSlider(sliderObj, args)
        {
            if (sliderActive)
            {
                sliderObj.slick('unslick');
                sliderActive = false;
                $('.brand-values-clone').empty();
            }

            // Clone brand values content to other site areas
            // #TODO: Attach this to the main slider init so it functions as a slider
            sliderObj.clone().addClass('brand-values--cloned').removeAttr('id').removeAttr('style').appendTo('.brand-values-clone');

            sliderObj.slick(args);
            sliderActive = true;

            if ($anchorElement.length)
            {
                if ($(window).width() < 750)
                {
                    switch (config.anchorPosition)
                    {
                        case 'above':
                            $anchorElement.css('margin-top', sliderObj.outerHeight() + 'px');
                            break;
                        default:
                            $anchorElement.css('margin-bottom', sliderObj.outerHeight() + 'px');
                            break;
                    }
                }
            }
        }
    }

    brandValueSliders.prototype = _.assignIn({}, brandValueSliders.prototype, {
        onUnload: function()
        {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);

            $(this.slider, this.wrapper).slick('unslick');
        },

        onBlockSelect: function(evt)
        {
            // Ignore the cloned version
            var $slide = $('.brand-values__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
            var slideIndex = $slide.data('slick-index');

            // Go to selected slide, pause autoplay
            $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
        },

        a11y: function(event, obj)
        {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);

            // Remove default Slick aria-live attr until slider is focused
            $list.removeAttr('aria-live');

            // When an element in the slider is focused set aria-live
            $wrapper.on('focusin', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.attr('aria-live', 'polite');
                }
            });

            // Remove aria-live
            $wrapper.on('focusout', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return brandValueSliders;
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function()
{
    var config = {
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        slideCount: 0
    };

    var sliderOptions = {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
    };

    function featuredCollection(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var wrapper = this.wrapper = '.featured-collection-wrap';
        var slider = this.slider = '#featured-collection-' + sectionId;
        var $slider = $(slider, wrapper);
        var sliderActive = false;

        var options = $.extend({}, sliderOptions, {
            prevArrow: slider + ' ~ .featured-collection__prev',
            nextArrow: slider + ' ~ .featured-collection__next',
            autoplay: $slider.data('autoplay'),
            autoplaySpeed: $slider.data('speed'),
            responsive: [
                {
                    breakpoint: 1480,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        // dots: true,
                        autoplay: $slider.data('autoplay-mobile'),
                    }
                },
                {
                    breakpoint: 512,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        // dots: true
                    }
                }
            ]
        });

        $slider.on('init', this.a11y.bind(this));

        initSlider($slider, options);

        function initSlider(sliderObj, args)
        {
            if (sliderActive)
            {
                sliderObj.slick('unslick');
                sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;

            $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each(function()
            {
                var $el = $(this);
                theme.QuantitySelectors.init($el);
            });
        }


        $('.product-finish').each(function()
        {
            var $el = $(this);
            var color = $el.attr('data-finish-style-style');
            var data = JSON.parse($('#product-finish-data').html());

            if (data.some(function(x)
            {
                return x.tag === color;
            }))
            {
                var colorData = data.filter(function(x)
                {
                    return x.tag === color;
                });
                var colorName = colorData[0].title;
                var colorStyle = colorData[0].style;
                $el.css("background", colorStyle);
                var parent = $el.parent();
                parent.find('.product-finish-label').text(colorName);
            }
        });

    }

    featuredCollection.prototype = _.assignIn({}, featuredCollection.prototype, {
        onUnload: function()
        {
            $(this.slider, this.wrapper).slick('unslick');
        },

        a11y: function(event, obj)
        {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);

            // Remove default Slick aria-live attr until slider is focused
            $list.removeAttr('aria-live');

            // When an element in the slider is focused set aria-live
            $wrapper.on('focusin', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.attr('aria-live', 'polite');
                }
            });

            // Remove aria-live
            $wrapper.on('focusout', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return featuredCollection;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.FeaturedCollections = (function()
{
    var selectors = {
        collectionLink: '.featured_colections__header-item',
    };

    function FeaturedCollections(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#Slideshow-' + sectionId;
        var activeCollectionHandle = $('[data-block-id]', $container).first().data('related-collection');

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

        $(selectors.collectionLink + '[data-related-collection=' + activeCollectionHandle + ']', $container).addClass('active');

        $(slideshow).on('beforeChange', function(event, slick, currentSlide, nextSlide)
        {
            var nextCollectionHandle = $('[data-slick-index="' + nextSlide + '"]:not(.slick-cloned) [data-related-collection]', $container).data('related-collection');
            if (nextCollectionHandle != activeCollectionHandle)
            {
                activeCollectionHandle = nextCollectionHandle;

                $(selectors.collectionLink, $container).removeClass('active');
                $(selectors.collectionLink + '[data-related-collection="' + activeCollectionHandle + '"]', $container).addClass('active');
            }
        });

        $(selectors.collectionLink, $container).on('click', function(evt)
        {
            evt.preventDefault();
            var $this = $(this);

            var relatedCollectionHandle = $this.data('related-collection');
            var $slide = $('.slick-slide[data-slick-index="' + $this.data('first-product') + '"]:not(.slick-cloned)', $container).first();
            var slideIndex = $slide.data('slick-index');
            $(slideshow).slick('slickGoTo', slideIndex);
        });
    }

    return FeaturedCollections;
})();

theme.FeaturedCollections.prototype = _.assignIn({}, theme.FeaturedCollections.prototype, {
    onUnload: function()
    {
        delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt)
    {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function()
    {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});


window.theme = window.theme || {};

theme.FeaturedProducts = (function()
{
    // var config = {
    //   mediaQuerySmall: 'screen and (max-width: 767px)',
    //   mediaQueryMediumUp: 'screen and (min-width: 768px)',
    //   slideCount: 0
    // };

    // var sliderOptions = {
    //   autoplay: false,
    //   arrows: true,
    //   dots: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   infinite: true
    // };

    // function featuredProducts(container) {
    //   var $container = this.$container = $(container);
    //   var sectionId = $container.attr('data-section-id');
    //   var wrapper = this.wrapper = '.featured-product-wrap';
    //   var slider = this.slider = '#featured-product-' + sectionId;
    //   var $slider = $(slider, wrapper);
    //   var sliderActive = false;

    //   var options = $.extend({}, sliderOptions, {
    //     prevArrow: slider + ' ~ .featured-product__prev',
    //     nextArrow: slider + ' ~ .featured-product__next'
    //   });

    //   $slider.on('init', this.a11y.bind(this));

    //   initSlider($slider, options);

    //   function initSlider(sliderObj, args) {
    //     if (sliderActive) {
    //       sliderObj.slick('unslick');
    //       sliderActive = false;
    //     }

    //     sliderObj.slick(args);
    //     sliderActive = true;
    //   }
    // }

    // featuredProducts.prototype = _.assignIn({}, featuredProducts.prototype, {
    //   onUnload: function() {
    //     $(this.slider, this.wrapper).slick('unslick');
    //   },

    //   a11y: function(event, obj) {
    //     var $list = obj.$list;
    //     var $wrapper = $(this.wrapper, this.$container);

    //     // Remove default Slick aria-live attr until slider is focused
    //     $list.removeAttr('aria-live');

    //     // When an element in the slider is focused set aria-live
    //     $wrapper.on('focusin', function(evt) {
    //       if ($wrapper.has(evt.target).length) {
    //         $list.attr('aria-live', 'polite');
    //       }
    //     });

    //     // Remove aria-live
    //     $wrapper.on('focusout', function(evt) {
    //       if ($wrapper.has(evt.target).length) {
    //         $list.removeAttr('aria-live');
    //       }
    //     });
    //   }
    var selectors = {
        slideshow: '[data-slideshow]'
    }


    function featuredProducts(container)
    {

        this.$container = $(container);
        this.$slideshows = $(selectors.slideshow, this.$container);

        $.each(this.$slideshows, function(index, slideshow)
        {

            theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

        });



    }


    return featuredProducts;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageRows = (function()
{

    function ImageRows(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#Slideshow-' + sectionId;

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return ImageRows;
})();

theme.ImageRows.prototype = _.assignIn({}, theme.ImageRows.prototype, {
    onUnload: function()
    {
        delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt)
    {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function()
    {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});

window.theme = window.theme || {};

theme.ContentSliders = (function()
{
    var config = {
        mediaQuerySmall: 'screen and (max-width: 600px)',
        mediaQueryMedium: 'screen and (min-width: 601px) and (max-width: 991px)',
        mediaQueryLargeUp: 'screen and (min-width: 992px)'
    };

    function contentSliders(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var wrapper = this.wrapper = '.content-slider-wrap';
        var slider = this.slider = '#content-slider-' + sectionId;
        var $slider = $(slider, wrapper);
        var sliderActive = false;

        var options = {
            infinite: $slider.data('infinite'),
            prevArrow: slider + ' ~ .content-slider__prev',
            nextArrow: slider + ' ~ .content-slider__next',
            arrows: $slider.data('arrows'),
            dots: $slider.data('dots'),
            autoplay: $slider.data('autoplay'),
            autoplaySpeed: $slider.data('speed'),
            slidesToShow: $slider.data('slides-show-desktop'),
            slidesToScroll: $slider.data('slides-scroll-desktop'),
            rows: $slider.data('rows-desktop'),
            slidesPerRow: $slider.data('per-row-desktop')
        };

        var tabletOptions = $.extend({}, options, {
            slidesToShow: $slider.data('slides-show-tablet'),
            slidesToScroll: $slider.data('slides-scroll-tablet'),
            rows: $slider.data('rows-tablet'),
            slidesPerRow: $slider.data('per-row-tablet')
        });

        var mobileOptions = $.extend({}, options, {
            arrows: $slider.data('arrows-mobile'),
            dots: $slider.data('dots-mobile'),
            autoplay: $slider.data('autoplay-mobile'),
            slidesToShow: $slider.data('slides-show-mobile'),
            slidesToScroll: $slider.data('slides-scroll-mobile'),
            rows: $slider.data('rows-mobile'),
            slidesPerRow: $slider.data('per-row-mobile')
        });

        $slider.on('init', this.a11y.bind(this));

        enquire.register(config.mediaQuerySmall, {
            match: function()
            {
                initSlider($slider, mobileOptions);
            }
        });

        enquire.register(config.mediaQueryMedium, {
            match: function()
            {
                initSlider($slider, tabletOptions);
            }
        });

        enquire.register(config.mediaQueryLargeUp, {
            match: function()
            {
                initSlider($slider, options);
            }
        });

        function initSlider(sliderObj, args)
        {
            if (sliderActive)
            {
                sliderObj.slick('unslick');
                sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;
        }

        $('.slideshow__video', wrapper).each(function()
        {
            var $el = $(this);
            theme.SlideshowVideo.init($el);
            theme.SlideshowVideo.loadVideo($el.attr('id'));
        });


    }

    contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
        onUnload: function()
        {
            $(this.slider, this.wrapper).slick('unslick');
        },

        a11y: function(event, obj)
        {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);

            // Remove default Slick aria-live attr until slider is focused
            $list.removeAttr('aria-live');

            // When an element in the slider is focused set aria-live
            $wrapper.on('focusin', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.attr('aria-live', 'polite');
                }
            });

            // Remove aria-live
            $wrapper.on('focusout', function(evt)
            {
                if ($wrapper.has(evt.target).length)
                {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return contentSliders;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function()
{
    function LatestBlogPosts(container)
    {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#Slideshow-' + sectionId;

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn({}, theme.LatestBlogPosts.prototype, {
    onUnload: function()
    {
        delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt)
    {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function()
    {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});

window.theme = window.theme || {};

theme.contentBlocks = (function()
{

    var selectors = {
        container: '.section-content-blocks',

    };

    function init(container)
    {

        var $container = $(container);
        var sectionId = $container.attr('data-section-id');
        var primarySlider = '#Slideshow-' + sectionId;
        var descriptionSlider = '#Slideshow-' + sectionId + 'body';

        if (isMobile.any)
        {
            $container.find('.slideshow__prev.content-block__prev').addClass('show');
            $container.find('.slideshow__next.content-block__next').addClass('show');
        } else
        {
            $('.content-block-slide-wrapper').on('mouseenter', function()
            {
                var $container = $(this).parent('.content-block-wrapper');
                $container.find('.slideshow__prev.content-block__prev').addClass('show');
                $container.find('.slideshow__next.content-block__next').addClass('show');
            });
            $('.content-block-slide-wrapper').on('mouseleave', function()
            {
                var $container = $(this).parent('.content-block-wrapper');
                $container.find('.slideshow__prev.content-block__prev').removeClass('show');
                $container.find('.slideshow__next.content-block__next').removeClass('show');
            });
        }





        var primarySliderOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: true,
            arrows: true,
            infinite: true,
            focusOnSelect: true,
            fade: false,
            adaptiveHeight: false,
            asNavFor: descriptionSlider,
            prevArrow: primarySlider + ' ~ .content-block__prev',
            nextArrow: primarySlider + ' ~ .content-block__next',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        // arrows: true,
                        fade: false,
                        dots: false
                    }
                }
            ]
        };


        var descriptionSliderOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            arrows: false,
            infinite: true,
            focusOnSelect: true,
            fade: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        // arrows: true,
                        fade: false,
                        dots: false,
                    }
                }
            ]
        };

        $(primarySlider).slick(primarySliderOptions);
        $(descriptionSlider).slick(descriptionSliderOptions);

    }

    return init;

})();

/*============================================================================
  PRODUCT FEATURED POINTS
==============================================================================*/
window.theme = window.theme || {};

theme.ProductFeaturedPointsEditor = (function()
{

    var selectors = {
        featuredPoints: '.product-featured-points',
    };

    function ProductFeaturedPointsEditor(container)
    {

        var $featuredPoints = $(container).find(selectors.featuredPoints);
        if (!$featuredPoints.length)
        {
            return;
        }
        var featuredPoints = this.featuredPoints = new theme.ProductFeaturedPoints($featuredPoints);

    }

    ProductFeaturedPointsEditor.prototype = _.assignIn({}, ProductFeaturedPointsEditor.prototype, {

        onUnload: function()
        {

        },

    });

    return ProductFeaturedPointsEditor;
})();
window.theme = window.theme || {};

theme.ShoppableImages = (function(container)
{

    var selectors = {
        container: '.section-shoppable-images',

    };

    function init()
    {

        var $container = $(selectors.container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = '#Slideshow-' + sectionId;

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);


        $('.shoppable-images-slider').waypoint({

            handler: function(direction)
            {

                this.destroy();
                loadFeaturePoints();

            },
            offset: '200%'
        });

        function loadFeaturePoints()
        {
            var cache = {
                articles: []
            };

            var $images = $('.shoppable-image-inner');

            var self = this;


            for (var i = 0; i < $images.length; i++)
            {

                var blogHandle = $($images[i]).attr('data-blog');
                var articleHandle = $($images[i]).attr('data-article');

                if (cache.articles.indexOf(articleHandle) > -1)
                {
                    return;
                } else
                {
                    cache.articles.push(articleHandle);

                }

                var pointsData = sessionStorage.getItem(articleHandle);

                if (!pointsData)
                {

                    $.get('/blogs/' + articleHandle + '?view=featured-points', function(data)
                    {

                        var _handle = $($images[i]).attr('data-article');
                        sessionStorage.setItem(_handle, data);
                        renderArticlePoints($($images[i]), data);

                    });


                } else
                {

                    renderArticlePoints($($images[i]), pointsData);

                }

            }
        }


        function renderArticlePoints(el, data)
        {
            var $image = $(el);

        }






    }

    return init;

})();




window.theme = window.theme || {};

theme.PageScrollAnimate = (function()
{

    var selectors = {
        container: '.scroll-animate',

    };

    function init()
    {

        if (!$(selectors.container))
        {
            return;
        }

        $(selectors.container).waypoint({

            handler: function(direction)
            {

                this.destroy();
                $(selectors.container).addClass('animated');
            },
            offset: '-100%'
        });

    }

    return {
        init: init
    }

})();

theme.PageScrollAnimate.init();
window.theme = window.theme || {};

theme.MegaMenu = (function()
{

    var selectors = {
        menu_trigger: '.site-nav__link',
        menu_container: '.mega-menu',
        submenu: '.mega-menu__submenu',
        submenu_heading: '.mega-menu__menu-left--heading'
    };

    function init()
    {
        var MegaContained = window.mega.contain;

        if (MegaContained)
        {
            var menus = $('.mega-menu');

            for (var i = 0; i < menus.length; i++)
            {
                var data = $(menus[i]).data('menu');
                $('[data-menu-trigger=' + data + ']').append($(menus[i]));
            }
        }
        else
        {
            var megaMenu = $('.mega-menu-wrapper');
            $('.site-header-wrapper').append(megaMenu);

        }


        $(selectors.menu_trigger).on('mouseenter', function()
        {
            showMenu(this);
        });

        $(selectors.menu_container).on('mouseenter', function()
        {
            var mega_menu_key = $(this).data('menu');
            $('[data-menu]').removeClass('visible');
            $('[data-menu=' + mega_menu_key + ']').addClass('visible');
        });

        $(selectors.menu_container).on('mouseleave', function()
        {
            hideMenu(this);
        });

        $(selectors.menu_trigger).on('mouseleave', function()
        {

            setTimeout(function()
            {
                if (!$('.mega-menu:hover').length && !$('[data-menu-trigger]:hover').length)
                {
                    hideMenu(this);
                }
            }, 500);

        });

        $(selectors.submenu_heading).on('mouseenter', function()
        {
            showSubmenu(this);
        });

        $(selectors.submenu_heading).on('mouseleave', function()
        {
            hideSubmenu(this);
        });

        function showMenu(_this)
        {

            $('[data-menu-trigger]').removeClass('active');
            $(_this).addClass('active');
            var mega_menu_key = $(_this).data('menu-trigger');
            $('[data-menu]').removeClass('visible');
            var $menu = $('[data-menu=' + mega_menu_key + ']');
            showSubmenu($menu.find('[data-submenu]').first());
            $menu.addClass('visible');
        }

        function showSubmenu(_this)
        {

            $('[data-submenu]').removeClass('visible');

            var mega_menu_key = $(_this).data('submenu');
            $('[data-submenu]').removeClass('visible');
            var $subMenuItem = $('[data-submenu=' + mega_menu_key + ']');

            if (!$subMenuItem.length)
            {
                return;
            }

            $subMenuItem.addClass('visible-transition');

            $subMenuItem.offset().top;

            $subMenuItem.addClass('visible').removeClass('visible-transition');
        }

        function hideMenu(_this)
        {

            $('[data-menu-trigger]').removeClass('active');
            $('[data-menu]').removeClass('visible');
        }

        function hideSubmenu(_this)
        {

            // $('[data-submenu]').removeClass('visible');
        }

    }

    return {
        init: init
    };

})();

theme.MegaMenu.init();

// theme.MegaMenu.init();

// window.theme = window.theme || {};

// theme.MegaMenu = (function() {

//   var selectors = {
//     menu_trigger: '.site-nav__link',
//     menu_container: '.mega-menu',
//     submenu: '.mega-menu__submenu',
//     submenu_heading: '.mega-menu__menu-left--heading'
//   };

//   function init() {
//     var MegaContained = window.mega.contain;

//     if (MegaContained) {
//       var menus = $('.mega-menu');

//       for (var i = 0; i < menus.length; i++) {
//         var data = $(menus[i]).data('menu');
//         $('[data-menu-trigger='+data+']').append($(menus[i]));
//       }
//     }
//     else {
//       var megaMenu =  $('.mega-menu-wrapper');
//       $('.site-header-wrapper').append(megaMenu);

//     }


//     $(selectors.menu_trigger).on('mouseenter', function(){
//       showMenu(this);
//     });

//     $(selectors.menu_container).on('mouseenter', function(){
//       var mega_menu_key = $(this).data('menu');
//       $('[data-menu]').removeClass('visible');
//       $('[data-menu='+mega_menu_key+']').addClass('visible');
//     });

//     $(selectors.menu_container).on('mouseleave', function(){
//       hideMenu(this);
//     });

//     $(selectors.menu_trigger).on('mouseleave', function(){
//       hideMenu(this);
//     });

//     $(selectors.submenu_heading).on('mouseenter', function(){
//       showSubmenu(this);
//     });

//     $(selectors.submenu_heading).on('mouseleave', function(){
//       hideSubmenu(this);
//     });

//     function showMenu(_this) {

//       var mega_menu_key = $(_this).data('menu-trigger');
//       $('[data-menu]').removeClass('visible');
//       $('[data-menu='+mega_menu_key+']').addClass('visible');
//     }

//     function showSubmenu(_this) {

//       var mega_menu_key = $(_this).data('submenu');
//       $('[data-submenu]').removeClass('visible');
//       $('[data-submenu='+mega_menu_key+']').addClass('visible');
//     }

//     function hideMenu(_this) {

//       $('[data-menu]').removeClass('visible');
//     }

//     function hideSubmenu(_this) {

//       $('[data-submenu]').removeClass('visible');
//     }

//   }

//   return {
//     init: init
//   };

// })();

// theme.MegaMenu.init();
window.theme = window.theme || {};

theme.collectionStickyFilter = (function()
{

    function collectionStickyFilter(options)
    {
        var selectors = {
            stickyFilter: '.bc-sf-filter-left-col'
        };

        // var stickyFilter = {
        //   parent: '#bc-sf-filter-wrapper'
        // };

        // $(selectors.stickyFilter).stickybits({ stickyBitStickyOffset: 100 });
        function closeSortDrawer()
        {
            $('.js-sort-wrapper').removeClass('active');
            $('html').removeClass('js-drawer-open');
            $('.sort__content').removeClass('active');
        }

        $('.collection-sort-inner .sorting__option').on('click', function(){
            if($(window).width()<992)
            {
                closeSortDrawer()
            }
        });


        $('.js-filter-btn').on('click', function()
        {
            $("html, body").scrollTop(0);
            $('.js-filter-wrapper').addClass('active');
            $('html').addClass('js-drawer-open');


            $('.js-close-filter-wrapper').on('click', function()
            {
                $('.js-filter-wrapper').removeClass('active');
                $('html').removeClass('js-drawer-open');
            });
        });

        $('.js-sort-btn').on('click', function()
        {
            $('.js-sort-wrapper').addClass('active');
            $('html').addClass('js-drawer-open');
            $('.sort__content').addClass('active');

            $('.js-close-sort-wrapper').on('click', function()
            {
                $('.js-sort-wrapper').removeClass('active');
                $('html').removeClass('js-drawer-open');
                $('.sort__content').removeClass('active');
            });
        });

        // $('.bc-sf-filter-option-item.bc-sf-filter-option-label').on('click', function(e){
        //   e.preventDefault();
        // });
        //see bcfilter for filter adjustments in modal


    }

    return collectionStickyFilter;
})();
theme.slideshows = theme.slideshows || {};
window.theme = window.theme || {};

theme.Catalogues = (function()
{

    function Catalogues(el)
    {
        var $el = $(el);
        var $slideshow = $el.find('[data-slideshow]');
        var slideshow = new theme.Slideshow($slideshow);
    }

    return Catalogues;

})();



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function()
{
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length)
    {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify)
    {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function()
    {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });



    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function()
    {
        $newAddressForm.addClass('active');
        $('.add-address-wrapper').addClass('active');
    });

    $('.address-edit-toggle').on('click', function()
    {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).addClass('active');
        $('.add-address-wrapper').addClass('active');
    });

    $('.js-address-back-btn').on('click', function()
    {
        $('.customer-address__edit').removeClass('active');
        $('.add-address-wrapper').removeClass('active');
        $('.customer-address__new').removeClass('active');
    });

    $('.address-delete').on('click', function()
    {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?'))
        {
            Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function()
{
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length)
    {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt)
    {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash()
    {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover')
        {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm()
    {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
        $('.create-account').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess()
    {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length)
        {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();

window.theme = window.theme || {};

theme.RegisterPage = (function()
{
    var selectors = {
        registerPage: '.register-page',
    };

    if (!$(selectors.registerPage).length)
    {
        return;
    }

    var validateABN = function(abn)
    {
        var isValid = true;
        abn = abn.replace(/[^0-9]/g, '');
        isValid &= abn && /^\d{11}$/.test(abn);

        if (isValid)
        {
            var weightedSum = 0;
            var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
            for (var i = 0; i < weight.length; i++)
            {
                weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
            }
            isValid &= ((weightedSum % 89) === 0);
        }

        return isValid;
    };

    var abnField = document.getElementById('CustomerFormABN');
    if (abnField !== undefined && abnField !== null)
    {
        abnField.addEventListener('input', function(event)
        {
            if (abnField.validity.typeMismatch || validateABN(abnField.value) != true)
            {
                abnField.setCustomValidity('Please enter a valid ABN.');
            } else
            {
                abnField.setCustomValidity('');
            }
        });
    }

    if ($('#CustomerFormCustomerType').length)
    {
        updateRegisterFormFields($('#CustomerFormCustomerType').val());

        $('#CustomerFormCustomerType').on('change', function()
        {
            updateRegisterFormFields($(this).val());
        });
    }

    $('.form-element--product-interest label:last-child input').on('change', function()
    {
        $('.form-element--product-interest label input').not(this).prop('checked', this.checked);
    });

    $('.form-element--product-interest label:not(:last-child) input').on('change', function()
    {
        $('.form-element--product-interest label:last-child input').prop('checked', false);
    });

    function updateRegisterFormFields(selector)
    {
        var activeGroup = theme.utils.handleize(selector);
        var activeSelector = '.form-element--' + activeGroup;

        $('.form-element--toggles').not(activeSelector).hide();
        $('.form-element--toggles').not(activeSelector).removeClass('form-element--visible');
        $('.form-element--toggles').not(activeSelector).prop('disabled', true);

        $(activeSelector).show();
        $(activeSelector).addClass('form-element--visible');
        $(activeSelector).prop('disabled', false);

        $('input[name="tags"]').val(activeGroup);
    };

})();


theme.InitToastPop = (function() {

    function InitToastPop(container) {

      var $container = this.$container = $( container );
      var $toast = $('#toast');
      var toastDelay = parseInt( $toast.data( 'delay' ) );
      var reappearTime = parseInt( $toast.data( 'reappear-time' ) );
      var toastEnabled = $toast.data( 'enabled' );
      var testMode = $toast.data('testmode');

      if (testMode) {
        showToast(toastDelay);
      } else {
        //If cookie doesn't exist or it's expired
        if (Cookies.get('toast_delay') === undefined || reappearTime == 0){
          showToast(toastDelay);
          createCookie(reappearTime);
        }
      }

      function showToast(toastDelay){
        //Only show if it hasn't already been shown during that browser session
        if (sessionStorage.toast != "shown" && $('html').hasClass('lt-ie9') == false){
          setTimeout(function() {

            $('#toast').addClass('toast--visible');
          }, toastDelay);

          // Safari Private Browsing Mode shiv
          if (typeof localStorage === 'object') {
              try {
                  localStorage.setItem('localStorage', 1);
                  localStorage.removeItem('localStorage');
                  sessionStorage.toast = "shown";

              } catch (e) {
                  Storage.prototype._setItem = Storage.prototype.setItem;
                  Storage.prototype.setItem = function() {};
              }
          }
        }  else if (testMode) {
          setTimeout(function() {

            $('#toast').addClass('toast--visible');
          }, toastDelay);
        }
      };

      function createCookie(reappearTime){
        if (reappearTime != 0){
          Cookies.set('toast_delay', 'value', { expires: reappearTime });
        }
      };


      $('.toast__close').on('click', function(evt)
      {
        evt.preventDefault();
        $('#toast').removeClass('toast--visible');
      });
    }

    return InitToastPop;
  })();




(function()
{
    var $filterBy = $('#BlogTagFilter');

    if (!$filterBy.length)
    {
        return;
    }

    $filterBy.on('change', function()
    {
        location.href = $(this).val();
    });

})();

document.addEventListener("DOMContentLoaded", function()
{
    var endlessScroll = new Ajaxinate({
        container: '#AjaxinateLoop',
        pagination: '#AjaxinatePagination',
        loadingText: 'Loading…'
    });
});


$(document).ready(function()
{
    // Object-fit polyfill initialise
    objectFitImages();

    // Hacky IE Lazysizes fix until we find a better solution or drop IE
    var ms_ie = !!window.navigator.userAgent.match(/MSIE|Trident/);
    if (ms_ie)
    {
        var lazyImageChecker = window.setInterval(function()
        {
            if (!$('img.lazyload').length) { window.clearInterval(lazyImageChecker); }
            $('img.lazyloading').each(function()
            {
                var imageSrc = $(this).attr('data-src');
                $(this).removeClass('lazyloading');
                $(this).get(0).src = imageSrc;
            });
        }, 3000);
    }

    var sections = new slate.Sections();
    sections.register('cart-template', theme.Cart);
    sections.register('product', theme.Product);
    sections.register('collection-template', theme.Filters);
    sections.register('product-template', theme.Product);
    sections.register('header-section', theme.HeaderSection);
    sections.register('map', theme.Maps);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('quotes', theme.Quotes);
    sections.register('brand-values', theme.BrandValueSliders);
    sections.register('featured-collection', theme.FeaturedCollection);
    sections.register('featured-collections', theme.FeaturedCollections);
    sections.register('featured-product', theme.FeaturedProducts);
    sections.register('image-row', theme.ImageRows);
    sections.register('content-slider', theme.ContentSliders);
    sections.register('latest-blog-posts', theme.LatestBlogPosts);
    sections.register('content-blocks', theme.contentBlocks);
    sections.register('shoppable-images', theme.ShoppableImages);
    sections.register('sticky-filter', theme.collectionStickyFilter);
    sections.register('catalogues', theme.Catalogues);
    sections.register('notice-bar', theme.NoticeBar);
    sections.register('brands', theme.Brands);
    sections.register('landing-page-featured-collection', theme.LandingPageFeaturedCollection);
    sections.register('toast-popup', theme.InitToastPop);



    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt)
    {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    $('a[href="#"]').on('click', function(evt)
    {
        evt.preventDefault();
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled())
    {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    if ('NProgress' in window)
    {
        NProgress.configure({ showSpinner: false });
    }


    // $('.collection-filters a').click(function(e){
    //   e.preventDefault();
    //   var $this = $(this);
    //   $gridContainer = $('.collection-grid .row');

    //   $gridContainer.empty().addClass('loading');

    //   $.ajax({
    //     url: $this.attr('href') + '?view=json'
    //   }).done(function(data) {
    //     var products = JSON.parse(data);
    //     template = $('#collection_grid_tpl').html();
    //     for (var i = 0; i < products.length; i++) {
    //       var newProduct = template;
    //       product = products[i];

    //       newProduct = newProduct.replace(/\{url\}/g, product.url);
    //       newProduct = newProduct.replace(/\{title\}/g, product.title);
    //       newProduct = newProduct.replace(/\{price\}/g, product.price);
    //       newProduct = newProduct.replace(/\{image\}/g, product.featured_image);
    //       $gridContainer.append(newProduct);
    //     }
    //   });

    // });

    // #TODO Replace this with some nicer logic - Rivets, slick, etc.
    theme.RecentlyViewed.showRecentlyViewed({ howManyToShow: 4 });

    $(document).on('click', '.pagination a', function(e)
    {
        var $this = $(this);
        if (!$this.hasClass('pagination__view-all'))
        {
            var $paginationElem = $this.parents('.pagination');
            var targetContainer = $paginationElem.data('target-container');
            var targetContainerOffset = $paginationElem.data('offset') || 0;

            if (targetContainer)
            {
                e.preventDefault();
                var $parentElem = $(targetContainer).parent();
                var targetURL = $this.attr('href');
                var match = RegExp('[?&]page=([^&]*)').exec(targetURL);
                var targetPage = match && decodeURIComponent(match[1].replace(/\+/g, ' ')) || 1;

                $parentElem.addClass('ajax-loading');

                $('html, body').animate({ scrollTop: $(targetContainer).offset().top + targetContainerOffset }, 500);
                // If page already exists
                if ($(targetContainer + '[data-page="' + targetPage + '"]').length)
                {
                    $(targetContainer).not('[data-page="' + targetPage + '"]').fadeOut('slow');
                    $(targetContainer + '[data-page="' + targetPage + '"]').fadeIn('slow');
                    history.pushState({}, targetPage, targetURL);
                    $parentElem.offset().top;
                    $parentElem.removeClass('ajax-loading');
                } else
                {
                    $.ajax({
                        type: 'GET',
                        dataType: 'html',
                        url: targetURL + '&view=ajax',
                        success: function(data)
                        {
                            $(targetContainer).not('[data-page="' + targetPage + '"]').fadeOut('slow');
                            history.pushState({}, targetPage, targetURL);
                            var appendData = $(data).find(targetContainer).prependTo($parentElem).hide();

                            var $qtyInputs = $('input[type="number"]', appendData);
                            $qtyInputs.each(function()
                            {
                                var $el = $(this);
                                theme.QuantitySelectors.init($el);
                            });

                            appendData.fadeIn('slow');
                            $parentElem.offset().top;
                            $parentElem.removeClass('ajax-loading');
                        }
                    });
                }
            }
        }
    });

    theme.CurrencySelectors.init();

    // $('#MainContent').on('click.quickAddToCart', '.product-grid-item .btn-add-to-cart', function(evt){
    //   var $this = $(this);
    //   var $container = $('#product-grid-item-' + $this.data('product-id'));
    //   var qty = $('input[name="quantity"]', $container).val();
    //   var progressElementSelector = $('[data-progress-element]', $container).data('progress-element');
    //   var $progressElement = progressElementSelector ? $(progressElementSelector) : $(this);

    //   if (qty > 0) {
    //     var variantId = $('#variant-select-' + $this.data('product-id') + ' option:selected').val();

    //     CartJS.addItem(variantId, qty, {}, {
    //       "success": function(data, textStatus, jqXHR) {
    //         iziToast.success({
    //           title: 'Success!',
    //           message: 'Added to cart.',
    //           position: 'bottomCenter',
    //           theme: 'light',
    //           buttons: [
    //             ['<button>View</button>', function (instance, toast) {
    //               instance.hide(toast);
    //               theme.CartDrawer.open();
    //             }]
    //           ]
    //         });
    //       }
    //     });
    //   } else {
    //     $progressElement.removeClass('loading');
    //     $progressElement.addClass('error');
    //     window.setTimeout(function(){
    //       $progressElement.removeClass('error');
    //     }, 1500);
    //     evt.stopImmediatePropagation();
    //   }
    // });


    $('.product-grid-form__items select').on('change', function()
    {
        var $selectedOption = $(this).find('option:selected');
        var productId = $(this).parents('.product-grid-form').data('product-id');
        var variantPrice = Currency.formatMoney(Currency.convert($selectedOption.data('price'), shop.currency, Currency.currentCurrency), Currency.currentFormat);

        $('#product-grid-item-' + productId + ' span.money').html(variantPrice);
        $('#product-grid-item-' + productId + ' input[name="quantity"]').val(0);
        $('#product-grid-item-' + productId + ' .btn-add-to-cart').removeClass('active');
        // $(this).attr('data-currency-' + shop.currency, $(this).html());
    });

    $('.product-grid-form__items').on('update.qtySelector', 'input[name="quantity"]', function(evt)
    {
        $('.product-grid-form__items').on('click', '.js-qty-select button', function()
        {
            //   var productId = $(this).parents('.product-grid-form').data('product-id');
            //   var selectedVariantId = $('#variant-select-' + productId + ' option:selected').val();
            //   var variantQuantity = $(this).siblings('input[name="quantity"]').val();
            //   // CartJS.updateItemById({selectedVariantId, variantQuantity});
        });
        var quantity = $(evt.target).val();
        var productId = $(this).parents('.product-grid-form').data('product-id');
        var $addButton = $('#product-grid-item-' + productId + ' .btn-add-to-cart');

        if (quantity > 0)
        {
            $addButton.addClass('active');
        } else
        {
            $addButton.removeClass('active');
        }
    });

    var readMoreLink = '<a aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more</a>';

    $('.js-read-more').readmore({
        speed: 75,
        collapsedHeight: 100,
        heightMargin: 100,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function(trigger, element, expanded)
        {
            $(element).toggleClass('readmore-expanded');
        }
    });

    // $('.js-fourth-level').on('click', function(){
    //   if ($(this).closest('.mobile-nav-wrapper').hasClass('fourth-nav--is-open')) {
    //     $(this).closest('.mobile-nav-wrapper').removeClass('fourth-nav--is-open');
    //   }
    //   else {
    //     $(this).closest('.mobile-nav-wrapper').addClass('fourth-nav--is-open');
    //   }
    // });

    // $('.js-fourth-level-back').on('click', function(){
    //   if ($(this).closest('.mobile-nav-wrapper').hasClass('fourth-nav--is-open')) {
    //     $(this).closest('.mobile-nav-wrapper').removeClass('fourth-nav--is-open');

    //   }
    //   else {
    //     $(this).closest('.mobile-nav-wrapper').addClass('fourth-nav--is-open');

    //   }
    // });

    $('#MainContent').on('click', '.js-add-to-cart', function()
    {
        if (!$(this).hasClass('active'))
        {
            $(this).addClass('active');
        }

        var productQuantity = $(this).attr('data-product-quantity');
        var productVariantId = $(this).attr('data-product');
        var productNote = '';
        var properties = {};
        if (productQuantity < 1)
        {
            productNote = 'on backorder';
            properties = { "Available": productNote, };
        }

        var mediaQuerySmall = 'screen and (max-width: 767px)';
        var mediaQueryMedium = 'screen and (min-width: 601px) and (max-width: 991px)';
        var mediaQueryLarge = 'screen and (min-width: 992px)';

        var openCart = function()
        {
            enquire.register(mediaQuerySmall, {
                match: function()
                {
                    iziToast.success({
                        title: 'Success!',
                        message: 'Added to cart',
                        position: 'bottomCenter',
                        theme: 'light',
                        buttons: [
                            [
                                '<button class="btn btn--secondary">View <span rv-html="cart.total_price | money | prepend \' - \'"></span></button>',
                                function(instance, toast)
                                {
                                    // window.location.href = '/cart';
                                    theme.CartDrawer.open();
                                },
                                false
                            ]
                        ],
                    });
                }
            });
            enquire.register(mediaQueryMedium, {
                match: function()
                {
                    iziToast.success({
                        title: 'Success!',
                        message: 'Added to cart',
                        position: 'bottomCenter',
                        theme: 'light',
                        buttons: [
                            [
                                '<button class="btn btn--secondary">View <span rv-html="cart.total_price | money | prepend \' - \'"></span></button>',
                                function(instance, toast)
                                {
                                    // window.location.href = '/cart';
                                    theme.CartDrawer.open();
                                },
                                false
                            ]
                        ],
                    });
                }
            });
            enquire.register(mediaQueryLarge, {
                match: function()
                {
                    theme.CartDrawer.open();
                }
            });
        };


        CartJS.addItem(productVariantId, 1, properties,
            {
                "success": function(data, textStatus, jqXHR)
                {
                    openCart();
                },
                "error": function(data, textStatus, jqXHR)
                {
                    iziToast.error({
                        title: 'Error!',
                        message: 'Couldnt be added to cart.',
                        position: 'bottomCenter',
                        theme: 'light',
                    });
                }
            });

    });

    var pacifierIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-pacifier" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px}</style></defs><title>pacifier</title><path d="M200.06 391.63a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z" fill="#faae3b"/><path d="M200.06 391.63c-.17.47-.41.92-.59 1.38.46.26.93.55 1.39.8A121.31 121.31 0 0 1 50 456a121.47 121.47 0 0 0 192.86-36.6 347.93 347.93 0 0 1-42.8-27.77z" fill="#f7991f"/><path d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z" fill="#7f2424"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7z" fill="#d73939"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-5.78 11.83-11.51 21.91-17.6 29.64 27.69 46.37 36 87.16 17.53 105.66a29.55 29.55 0 0 1-5.24 4.05c26.26 8.56 47.76 8 59.79-4.05 23.95-23.95 3.03-85.26-46.84-147.72zM214.23 197a209.6 209.6 0 0 1 22.05-12.21 71.18 71.18 0 0 0 12.42-7.64c-58.33-46.58-115.64-67.88-142.48-51 26.06 8.51 56.85 26.15 87.93 51 4.02 3.02 11.25 10.31 20.08 19.85z" fill="#be3434"/><path d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z" fill="#fcf1d1"/><path d="M454.83 45.17S410.2-3.45 353.31 15.71c28.41 9.25 47 29.46 47 29.46s76.5 70.08 0 146.59c-61.92 61.92-111.85 15.15-139.61 72-7.05 14.44-14 26.24-21.68 34.37 36.72 26.74 56.12 6.76 76.22-34.37 27.76-56.81 77.69-10 139.61-72 76.49-76.51-.02-146.59-.02-146.59z" fill="#f4ddaa"/><path class="cls-8" d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z"/><path class="cls-8" d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z"/><path class="cls-8" d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7zm-122.8 140.33a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z"/></svg>';
    var dummyLinkTooltip = '<div id="dummy-link-tooltip" class="hidden">' + pacifierIcon + ' This is a dummy link.</div>';
    $('body').append(dummyLinkTooltip);

    tippy('a[href="#"]:not(.btn):not("#CartDrawer a")', {
        html: '#dummy-link-tooltip',
        size: 'small',
        animation: 'shift-toward',
        placement: 'right',
        trigger: 'mouseenter focus',
    });

    tippy('a[href="#"].btn', {
        html: '#dummy-link-tooltip',
        size: 'small',
        animation: 'shift-toward',
        placement: 'right',
        trigger: 'click',
    });

    if (window.location.hostname == 'localhost')
    {
        document.documentElement.classList.add('localhost');
    }


    //////// mage ////////

    $(document).ready(function()
    {
        $('a[href^="#"]:not(.faq-sidebar__link)').click(function(e)
        {
            e.preventDefault();

            var scrollOffset = 0;
            if ($(this).attr('href') == '#next-section')
            {
                var next = $(this).closest('.shopify-section').next();
                $(window).stop(true).scrollTo(next, {
                    duration: 1000,
                    interrupt: !isMobile.apple.device,
                    offset: -scrollOffset
                });
            } else
            {
                scrollOffset = $('.site-header').height();
                $(window).stop(true).scrollTo(this.hash, {
                    duration: 1000,
                    interrupt: !isMobile.apple.device,
                    offset: -scrollOffset
                });
            }

        });
    });


    $(".sort__title").click(function(e)
    {
      if ($(".sort__title").hasClass("expanded")) {
      $(".sort__title").removeClass("expanded");
        $('body').removeClass("open-sorting");
      }
      else {
      	$(".sort__title").addClass("expanded");
        $('body').addClass("open-sorting");
      }
        $(".sort__content").slideToggle();
    })

    $('[data-sorting-close]').on('click',function(e){
        e.preventDefault();
      $(".sort__title").removeClass("expanded");
        $('body').removeClass("open-sorting");
        $(".sort__content").slideUp();
    })

    function handleCollectionWrapperSpace(timer = 300) {
        if ($(window).outerWidth() > 991) {
            setTimeout(() => {
                var $collectionWrapper = $('.collection-wrapper')
                var $filterSelectedItems = $('.bc-sf-filter-selected-items')

                if ($filterSelectedItems.length > 0) {
                    $collectionWrapper.css('margin-top', $filterSelectedItems.outerHeight() + 32)
                } else {
                    $collectionWrapper.css('margin-top', 96)
                }
            }, timer)
        }
    }

    // initial
    handleCollectionWrapperSpace(300)

    $('#bc-sf-filter-tree').on('click', '.bc-sf-filter-option-block', function(e) {
        if ($(window).outerWidth() > 991) {
            var $allFilterBlockContents = $('.bc-sf-filter-option-block').not(this)
            handleCollectionWrapperSpace()

            if ($allFilterBlockContents.length > 0) {
                $allFilterBlockContents.each(function() {
                    var $this = $(this);
                    var $filterBlockContent = $this.find('.bc-sf-filter-block-content');
                    var $filterArrow = $this.find('.bc-sf-filter-block-title h3 span');

                    if ($filterBlockContent.is(':visible')) {
                        $filterBlockContent.stop().slideToggle();
                        $filterArrow.stop().addClass('up');
                    }
                })
            }
        }
    })

    $('#bc-sf-filter-tree').on('click', '.bc-sf-filter-clear-all', function(e) {
        handleCollectionWrapperSpace()
    })

    $('#bc-sf-filter-tree').on('click', '.bc-sf-filter-clear', function(e) {
        handleCollectionWrapperSpace()
    })
});

document.addEventListener("DOMContentLoaded", function()
{
    var endlessScroll = new Ajaxinate({
        container: '#AjaxinateLoopGallery',
        pagination: '#AjaxinatePaginationGallery',
        loadingText: 'LoadingâŚ'
    });

    $(".sorting__option").on("click touchstart tap", function(event)
    {
        let target = $(event.target);

        updateSortOrder(target);
    })

    function updateSortOrder(target)
    {
        let value = target.data("value");
        const sortText = $.trim(target.text())

        $('.js-sort-name').html(sortText)
        bcsffilter.onChangeData(theme.utils.updateQueryStringParameter('sort', value, window.location.href), 'sort');
        $(".sorting__option.selected").removeClass('selected');
        target.addClass('selected');
        $(".sort__title").removeClass("expanded")
        $(".sort__content").slideUp();
    }
});

$(document).ready(function()
{

    $("#BusinessIntendedUse").click(function(event)
    {
        event.preventDefault();
        $('.use-option__container').hasClass('expanded') ? $('.use-option__container').removeClass('expanded') : $('.use-option__container').addClass('expanded');
    });

    $(".use-option__items li").click(function(event)
    {
        var target = $(event.target);
        $("#BusinessIntendedUse").val($.trim(target.text()));
        $('.use-option__container').hasClass('expanded') ? $('.use-option__container').removeClass('expanded') : $('.use-option__container').addClass('expanded');
    });

    $('.faq-sidebar-sticky').stickybits({ stickyBitStickyOffset: 100 });

});

$(document).ready(function()
{

    $("#BusinessType").click(function(event)
    {
        event.preventDefault();
        $('.use-option__container_type').hasClass('expanded') ? $('.use-option__container_type').removeClass('expanded') : $('.use-option__container_type').addClass('expanded');
    });

    $(".use-option__items_type li").click(function(event)
    {
        var target = $(event.target);
        $("#BusinessType").val($.trim(target.text()));
        $('.use-option__container_type').hasClass('expanded') ? $('.use-option__container_type').removeClass('expanded') : $('.use-option__container_type').addClass('expanded');
    });

    $('.faq-sidebar-sticky').stickybits({ stickyBitStickyOffset: 100 });

});

$(document).ready(function()
{
    $('.specifiers__images').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

// $(document).ready(function() {
//   $('.catalogues__images').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     responsive: [
//       {
//         breakpoint: 1200,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3
//         }
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
// });

function addEventListenerEapps(el, eventName, handler)
{
    if (el.addEventListener) { el.addEventListener(eventName, handler); }
    else { el.attachEvent('on' + eventName, function() { handler.call(el); }); }
}

addEventListenerEapps(document, 'appReady.EappsFormBuilder', function(e)
{
    setTimeout(function(e)
    {
        $('#does-your-company-have-a-showroom-No').prop('checked', true);

        $('#does-your-company-have-a-showroom-Yes').change(
            function()
            {
                if ($(this).is(':checked'))
                {
                    $('.eapps-form-group').show();
                }
            });

        $('#does-your-company-have-a-showroom-No').change(function()
        {
            if ($(this).is(':checked'))
            {
                $('.eapps-form-group').hide();
            }
        });
    }, 1000)
});

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}

function getUrlParam(parameter, defaultvalue){
  var urlparameter = defaultvalue;
  if(window.location.href.indexOf(parameter) > -1){
      urlparameter = getUrlVars()[parameter];
      }
  return urlparameter;
}

// Ensure sort option is selected when page loads
$(document).ready(function() {

    if (typeof bcsffilter === "undefined") return;

    let sortOption = getUrlParam("sort");
    let target = $('.js-sort-wrapper [data-value="' + sortOption + '"]');

    bcsffilter.onChangeData(theme.utils.updateQueryStringParameter('sort', target.data("value"), window.location.href), 'sort');
    target.addClass('selected');
});

$(document).ready(function () {

    var roomSubCollections = document.getElementsByClassName('room-sub-collections');
    var roomLinks = document.getElementsByClassName('room-link');

    $('.room-viewall-link').click(function (event) {
        event.stopPropagation();
    });

    function addEventListenersToDropdownLinks() {
        for (var i = 0; i < roomLinks.length; i++) {
            roomLinks[i].addEventListener('click', function (event) {
                event.preventDefault();
                var dropDown = this.nextElementSibling;
                var isCollapsed = dropDown.getAttribute('data-collapsed') === 'true';
                var dropDownLink = this;

                collapseAllDropdowns();

                if (isCollapsed) {
                    expandDropdown(dropDown);

                    setTimeout(function () {
                        var new_position = $(dropDownLink).offset();
                        $('html, body').stop().animate({ scrollTop: new_position.top - 150 }, 500);
                    }, 500);
                }
            }, false);
        }
    }

    function expandDropdown(element) {
        var isCollapsed = element.getAttribute('data-collapsed');

        if (isCollapsed == 'false') {
            return
        }

        var dropdownHeight = element.scrollHeight;
        element.style.height = dropdownHeight + 'px';
        element.addEventListener('transitionend', function (e) {
            element.removeEventListener('transitionend', arguments.callee);
            // remove inline height style at end of transition
            element.style.height = '';
        });

        element.previousElementSibling.setAttribute('data-collapsed', 'false');
        element.setAttribute('data-collapsed', 'false');
    }

    function collapseAllDropdowns() {
        for (var i = 0; i < roomSubCollections.length; i++) {
            roomSubCollections[i].setAttribute('data-collapsed', 'true');
            roomSubCollections[i].style.height = 0 + 'px';
        }

        for (var i = 0; i < roomLinks.length; i++) {
            roomLinks[i].setAttribute('data-collapsed', 'true');
        }
    }

    addEventListenersToDropdownLinks();
    collapseAllDropdowns();
})

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$(document).ready(function()
{
    theme.prices.updatePrice();
    if(window.location.href.indexOf('?contact_posted=true') > -1 && $('#open-sample-modal')) {
        $('#open-sample-modal').trigger('click');
    }
    $('#form-submit').on('click',function(){
        var errorCounter = 0
        var errorEmail = 0
        $('#order-sample #contact_form [data-form-required]').each(function(){
            if($(this).val() == '') {
                errorCounter++;
                $(this).addClass('error');
            }
        })

        if($('#order-sample #ContactFormCountry').val() == '---') {
            errorCounter++;
            $('#order-sample #ContactFormCountry').addClass('error');
        }
        if($('#order-sample #ContactFormEmail').val() != '') {
            if(!validateEmail($('#order-sample #ContactFormEmail').val())) {
                errorEmail++;
                $('#order-sample #ContactFormEmail').addClass('error')
                $('#order-sample .email-error').removeClass('hide')
                return;
            }
        }

        if(errorCounter > 0) {
            $('.form-errors').removeClass('hide')
        }
        else {
            $('#order-sample #contact_form').trigger('submit')
        }
    })
    $('#order-sample #contact_form input').on('click',function(){
        $('#order-sample #contact_form input').removeClass('error')
        $('#order-sample #ContactFormCountry').removeClass('error')
        $('#order-sample .email-error').addClass('hide')
        $('.form-errors').addClass('hide')
    })
    $('#order-sample #ContactFormCountry').on('change',function(){
        $('#order-sample #contact_form [data-form-required]').removeClass('error')
        $('#order-sample #ContactFormCountry').removeClass('error')
        $('#order-sample .email-error').addClass('hide')
        $('.form-errors').addClass('hide')
    })

    function toggleBlock() {
        $('.toggle-block').each((_, elm) => {
            const $elm = $(elm);
            const $toggleHeader = $elm.find('.toggle-header');
            $toggleHeader.on('click', e => {
                const $current = $(e.currentTarget);
                $current.parents('.toggle-block').toggleClass('opened');
            });
        });
    }

    toggleBlock();
});

class AjaxCart
{
    changeQuantity(itemKey, quantity)
    {
        let id = itemKey.split(':')[0];

        $.ajax({
            type: 'post',
            url: '/cart/change.js',
            dataType: 'json',
            data:
            {
              'quantity': quantity,
              'id': id
            },
            success: cart => this.onCartChanged(cart, quantity, id)
        });
    }

    onCartChanged(cart, quantity, id)
    {
        this.updateLineItems(cart);
        this.updateCartTotal(cart);

        if (quantity == 0)
        {
            this.removeRow(id);
        }

        if (cart.items.length == 0)
        {
            location.reload();
        }
    }

    updateLineItems(cart)
    {
        cart.items.forEach(item =>
        {
            this.updateLineItem(item.id, item.quantity, item.line_price);
        });
    }

    updateLineItem(id, quantity, total)
    {
        let selector = `tr[data-variant_id=${id}]`;
        let $row = $(selector); // class = "quantity";
        let $quantity = $row.find('.quantity');

        this.updateLineItemTotal($row, total);
    }

    updateLineItemTotal($row, total)
    {
        let $element = $row.find('.cart__total strong');
        let value = this.toMoney(total);

        $element.html(value);
    }

    updateCartTotal(cart)
    {
        let $element = $('#js-cart-total');
        let value = this.toMoney(cart.total_price);

        $element.html(value);
    }

    toMoney(cents)
    {
        return `$${(cents / 100).toFixed(2)}`;
    }

    removeRow(id)
    {
        let selector = `tr[data-variant_id=${id}]`;
        let $row = $(selector);

        $row.remove();
    }
}

theme.AjaxCart = new AjaxCart();


/**
 * Logic to determine whether a product should be displayed as quote only.
 * 
 * Quote only applies when:
 * - product doesn't have tag "au-allow-sale"
 * - user is visiting from Australia 
 */
function isQuoteOnly() {
    const quoteOnlyCountries = [ "AU" ];
    const countryCode = window.getDataStorage('VISITING_USER_COUNTRY_CODE');
    const currentProductTags = window.shop.currentProduct.tags;

    if (currentProductTags == null) {
        return false;
    }

    return quoteOnlyCountries.includes(countryCode) && ! currentProductTags.includes("au-allow-sale");
}

/** 
 * Logic to show/hide purchase buttons on product page  
 */
function controlProductPurhcaseButtons() {
    const form = $('.product-form');
    
    if (!form){
        return;
    }

    const quoteButton = form.find('.rfq-btn');
    const addToCartButton = form.find('.add-to-cart-btn');
    const buyFromStockistButton = form.find('.buy-online-btn-wrapper');

    if (isQuoteOnly()) {
        // buyFromStockistButton.show();
        addToCartButton.hide();
        quoteButton.show();
    } else {
        // buyFromStockistButton.hide();
        addToCartButton.show();
        quoteButton.hide();
    }
}

controlProductPurhcaseButtons();

// Re-control button because the add to quote button is added with javascript
setTimeout(function() {
    controlProductPurhcaseButtons();
}, 100 )

// ===== FAQ SIDEBAR FIX (EXACT ALIGNMENT) =====
$(document).ready(function() {
  var STICKY_TOP = 100; 
  var isAnimating = false;
  var bodyEl = document.body;

  function getAbsoluteTop(element) {
    var rect = element.getBoundingClientRect();
    return rect.top + bodyEl.scrollTop;
  }
  $(document).on('click', '.faq-sidebar__link', function(e) {
    var href = $(this).attr('href');
    var target = document.querySelector(href);
    
    if (!target) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    $('.faq-sidebar__link').removeClass('active');
    $(this).addClass('active');
    var targetPosition = getAbsoluteTop(target) - STICKY_TOP;

    isAnimating = true;
    $(bodyEl).stop(true, true).animate({
      scrollTop: targetPosition
    }, 400, function() {
      setTimeout(function() { isAnimating = false; }, 50);
    });
  });

  bodyEl.addEventListener('scroll', function() {
    if (isAnimating) return;

    var currentId = "";
    var categories = $('.faq-item__category');
    
    categories.each(function() {
      var rect = this.getBoundingClientRect();
      if (rect.top <= STICKY_TOP + 20) {
        currentId = this.id;
      }
    });

    if (bodyEl.scrollTop + bodyEl.clientHeight >= bodyEl.scrollHeight - 20) {
      currentId = categories.last().attr('id');
    }

    if (currentId !== "") {
      var activeLink = $('.faq-sidebar__link[href="#' + currentId + '"]');
      if (!activeLink.hasClass('active')) {
        $('.faq-sidebar__link').removeClass('active');
        activeLink.addClass('active');
      }
    }
  });
  setTimeout(function() {
    bodyEl.dispatchEvent(new Event('scroll'));
  }, 500);
});
// ===== FAQ SIDEBAR FIX END =====

// ===== Popup function for Contact Form Builder APP (form ==> Warrenty form) =====
window.myWarrentylodge = function() {
    var popup = document.getElementById("myPopup");
    if (popup) {
        popup.classList.toggle("show");
    }
};